// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseURL: 'http://localhost:8080' | (string & {})
}

export type DefaultHttpStatusCode = HttpStatusCode

export const HttpStatus = {
  '100_CONTINUE': '100 CONTINUE',
  '101_SWITCHING_PROTOCOLS': '101 SWITCHING_PROTOCOLS',
  '102_PROCESSING': '102 PROCESSING',
  '103_EARLY_HINTS': '103 EARLY_HINTS',
  '200_OK': '200 OK',
  '201_CREATED': '201 CREATED',
  '202_ACCEPTED': '202 ACCEPTED',
  '203_NON_AUTHORITATIVE_INFORMATION': '203 NON_AUTHORITATIVE_INFORMATION',
  '204_NO_CONTENT': '204 NO_CONTENT',
  '205_RESET_CONTENT': '205 RESET_CONTENT',
  '206_PARTIAL_CONTENT': '206 PARTIAL_CONTENT',
  '207_MULTI_STATUS': '207 MULTI_STATUS',
  '208_ALREADY_REPORTED': '208 ALREADY_REPORTED',
  '226_IM_USED': '226 IM_USED',
  '300_MULTIPLE_CHOICES': '300 MULTIPLE_CHOICES',
  '301_MOVED_PERMANENTLY': '301 MOVED_PERMANENTLY',
  '302_FOUND': '302 FOUND',
  '303_SEE_OTHER': '303 SEE_OTHER',
  '304_NOT_MODIFIED': '304 NOT_MODIFIED',
  '307_TEMPORARY_REDIRECT': '307 TEMPORARY_REDIRECT',
  '308_PERMANENT_REDIRECT': '308 PERMANENT_REDIRECT',
  '400_BAD_REQUEST': '400 BAD_REQUEST',
  '401_UNAUTHORIZED': '401 UNAUTHORIZED',
  '402_PAYMENT_REQUIRED': '402 PAYMENT_REQUIRED',
  '403_FORBIDDEN': '403 FORBIDDEN',
  '404_NOT_FOUND': '404 NOT_FOUND',
  '405_METHOD_NOT_ALLOWED': '405 METHOD_NOT_ALLOWED',
  '406_NOT_ACCEPTABLE': '406 NOT_ACCEPTABLE',
  '407_PROXY_AUTHENTICATION_REQUIRED': '407 PROXY_AUTHENTICATION_REQUIRED',
  '408_REQUEST_TIMEOUT': '408 REQUEST_TIMEOUT',
  '409_CONFLICT': '409 CONFLICT',
  '410_GONE': '410 GONE',
  '411_LENGTH_REQUIRED': '411 LENGTH_REQUIRED',
  '412_PRECONDITION_FAILED': '412 PRECONDITION_FAILED',
  '413_CONTENT_TOO_LARGE': '413 CONTENT_TOO_LARGE',
  '413_PAYLOAD_TOO_LARGE': '413 PAYLOAD_TOO_LARGE',
  '414_URI_TOO_LONG': '414 URI_TOO_LONG',
  '415_UNSUPPORTED_MEDIA_TYPE': '415 UNSUPPORTED_MEDIA_TYPE',
  '416_REQUESTED_RANGE_NOT_SATISFIABLE': '416 REQUESTED_RANGE_NOT_SATISFIABLE',
  '417_EXPECTATION_FAILED': '417 EXPECTATION_FAILED',
  '418_I_AM_A_TEAPOT': '418 I_AM_A_TEAPOT',
  '421_MISDIRECTED_REQUEST': '421 MISDIRECTED_REQUEST',
  '422_UNPROCESSABLE_CONTENT': '422 UNPROCESSABLE_CONTENT',
  '422_UNPROCESSABLE_ENTITY': '422 UNPROCESSABLE_ENTITY',
  '423_LOCKED': '423 LOCKED',
  '424_FAILED_DEPENDENCY': '424 FAILED_DEPENDENCY',
  '425_TOO_EARLY': '425 TOO_EARLY',
  '426_UPGRADE_REQUIRED': '426 UPGRADE_REQUIRED',
  '428_PRECONDITION_REQUIRED': '428 PRECONDITION_REQUIRED',
  '429_TOO_MANY_REQUESTS': '429 TOO_MANY_REQUESTS',
  '431_REQUEST_HEADER_FIELDS_TOO_LARGE': '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
  '451_UNAVAILABLE_FOR_LEGAL_REASONS': '451 UNAVAILABLE_FOR_LEGAL_REASONS',
  '500_INTERNAL_SERVER_ERROR': '500 INTERNAL_SERVER_ERROR',
  '501_NOT_IMPLEMENTED': '501 NOT_IMPLEMENTED',
  '502_BAD_GATEWAY': '502 BAD_GATEWAY',
  '503_SERVICE_UNAVAILABLE': '503 SERVICE_UNAVAILABLE',
  '504_GATEWAY_TIMEOUT': '504 GATEWAY_TIMEOUT',
  '505_HTTP_VERSION_NOT_SUPPORTED': '505 HTTP_VERSION_NOT_SUPPORTED',
  '506_VARIANT_ALSO_NEGOTIATES': '506 VARIANT_ALSO_NEGOTIATES',
  '507_INSUFFICIENT_STORAGE': '507 INSUFFICIENT_STORAGE',
  '508_LOOP_DETECTED': '508 LOOP_DETECTED',
  '509_BANDWIDTH_LIMIT_EXCEEDED': '509 BANDWIDTH_LIMIT_EXCEEDED',
  '510_NOT_EXTENDED': '510 NOT_EXTENDED',
  '511_NETWORK_AUTHENTICATION_REQUIRED': '511 NETWORK_AUTHENTICATION_REQUIRED'
} as const

export type HttpStatus = (typeof HttpStatus)[keyof typeof HttpStatus]

export type HttpStatusCode = {
  is4xxClientError?: boolean
  is5xxServerError?: boolean
  is1xxInformational?: boolean
  is2xxSuccessful?: boolean
  is3xxRedirection?: boolean
  error?: boolean
}

export type StorefrontApiError = {
  httpStatus: DefaultHttpStatusCode | HttpStatus
  timestamp: string
  detail: string
  message?: string | null
  requestId?: string | null
}

export type Token = {
  value: string
}

export type PasswordResetDto = {
  mail: string
}

export type ChangePasswordDto = {
  token: Token
  password: string
}

export type BatchRuntimeRequest = {
  productIds: Array<number>
  /**
   * Scale (amount) of products
   */
  scale: number
  filters?: Array<string> | null
}

export const Availability = {
  ON_STOCK: 'OnStock',
  WAREHOUSE: 'Warehouse',
  ORDERED: 'Ordered',
  ON_ORDER: 'OnOrder',
  AVAILABLE: 'Available',
  NOT_AVAILABLE: 'NotAvailable',
  UNKNOWN: 'Unknown'
} as const

export type Availability = (typeof Availability)[keyof typeof Availability]

export type BatchProductPriceUpdate = {
  productId: number
  price?: SimplePrice | null
  stock?: SimpleStock | null
}

export const ChronoUnit = {
  NANOS: 'Nanos',
  MICROS: 'Micros',
  MILLIS: 'Millis',
  SECONDS: 'Seconds',
  MINUTES: 'Minutes',
  HOURS: 'Hours',
  HALF_DAYS: 'HalfDays',
  DAYS: 'Days',
  WEEKS: 'Weeks',
  MONTHS: 'Months',
  YEARS: 'Years',
  DECADES: 'Decades',
  CENTURIES: 'Centuries',
  MILLENNIA: 'Millennia',
  ERAS: 'Eras',
  FOREVER: 'Forever'
} as const

export type ChronoUnit = (typeof ChronoUnit)[keyof typeof ChronoUnit]

export type Money = {
  /**
   * Amount of currency units with two decimal places
   */
  value: number
  /**
   * ISO 4217 three letter currency symbol, e.g. EUR
   */
  currency: string
}

export type PackagingModel = {
  /**
   * Unit of the contents of an order, e.g "bottle".
   */
  contentUnit?: string | null
  /**
   * The amount to be ordered between different single orders.
   */
  intervalQuantity: number
  /**
   * Unit in which the product can be ordered, e.g "six-pack"
   */
  orderUnit?: string | null
  /**
   * The minimum quantity of orderUnits that must be ordered to buy a product.
   */
  minQuantity: number
  /**
   * The amount of orderUnits that the supplier delivers in one single order.
   */
  supplierPackingQuantity: number
  /**
   * The amount of orderUnits for the given price.
   */
  priceQuantity: number
  /**
   * The number of contentUnits that belong to an orderUnit, e.g 6 bottles (contentUnit) in 1 six-pack (orderUnit). The user buys orderUnits, and these contain contentUnits.
   */
  numberContentUnitPerOrderUnit: number
}

export type SimplePrice = {
  purchasePrice?: Money | null
  resellPrice: Money
  subscriptionModel?: SubscriptionModel | null
  packagingModel?: PackagingModel | null
  supplierRowId?: number | null
  canBeRented: boolean
}

export type SimpleStock = {
  status: Availability
  count: number
  deliveryDate?: string | null
  incomingAmount?: number | null
  isUnlimitedStock: boolean
}

export type SubscriptionModel = {
  /**
   * Determines how many billingPeriodUnits lie between bills.
   */
  billingPeriod?: number | null
  /**
   * Unit of time that is multiplied with the billingPeriod to determine how frequent the buyer will be billed.
   */
  billingPeriodUnit?: ChronoUnit | null
  /**
   * Determines for how many subscriptionPeriodUnits a subscription lasts.
   */
  subscriptionPeriod?: number | null
  /**
   * Unit of time that is multiplied with the subscriptionPeriod to determine how long the subscription lasts.
   */
  subscriptionPeriodUnit?: ChronoUnit | null
}

export type RuntimeRequest = {
  productId: number
  /**
   * Scale (amount) of products
   */
  scale: number
  filters?: Array<string> | null
}

export const Condition = {
  NEW: 'NEW',
  BULK: 'BULK',
  BUILD_TO_ORDER: 'BUILD_TO_ORDER',
  FACTORY_REFURBISHED: 'FACTORY_REFURBISHED',
  REFURBISHED: 'REFURBISHED',
  DEMONSTRATION_MODEL: 'DEMONSTRATION_MODEL',
  B_STOCK: 'B_STOCK',
  RMA_STOCK: 'RMA_STOCK',
  USED: 'USED',
  NOT_FOR_RESALE: 'NOT_FOR_RESALE',
  NEWPULL: 'NEWPULL',
  USEDPULL: 'USEDPULL'
} as const

export type Condition = (typeof Condition)[keyof typeof Condition]

export type Grading = {
  /**
   * Grading letter like 'A', 'B', 'C', 'D'
   */
  code: string
  text?: string | null
  warrantyMonths: number
}

export type ProductPriceUpdate = {
  productId: number
  price?: SimplePrice | null
  stock?: SimpleStock | null
  suppliers: Array<SupplierRow>
}

export type Scale = {
  minScale: number
  resellPrice: Money
}

export type SupplierRow = {
  id: number
  supplierName: string
  supplierPid?: string | null
  price?: SimplePrice | null
  stock?: SimpleStock | null
  scales: Array<Scale>
  condition?: Condition | null
  grading?: Grading | null
  /**
   * This field is sunset since 28.07.2026.
   */
  conditionDescription?: string | null
}

export type Company = {
  name: string
  street: string
  zipCode: string
  city: string
  country: string
  phone: string
}

export type Contact = {
  email: string
  firstName: string
  lastName: string
  contactTitle: ContactTitle
  /**
   * 2 letter language code according to ISO 639-1
   */
  alpha2language: string
}

export const ContactTitle = {
  MALE: 'Male',
  FEMALE: 'Female',
  DIVERSE: 'Diverse',
  UNSPECIFIED: 'Unspecified'
} as const

export type ContactTitle = (typeof ContactTitle)[keyof typeof ContactTitle]

export type SelfRegistration = {
  person: Contact
  company: Company
}

export type Email = {
  email: string
}

export const EmailStatus = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  REGISTERED: 'REGISTERED',
  INVITED: 'INVITED',
  BLACKLISTED: 'BLACKLISTED'
} as const

export type EmailStatus = (typeof EmailStatus)[keyof typeof EmailStatus]

export type SelfInvite = {
  email: string
  /**
   * 2 letter language code according to ISO 639-1
   */
  alpha2language: string
}

export type InvitationRegistration = {
  token: Token
  firstName: string
  lastName: string
  password: string
  contactTitle: ContactTitle
  customTermsConfirmation: boolean
  termsConfirmation: boolean
  /**
   * 2 letter language code according to ISO 639-1
   */
  alpha2language: string
}

export type ValidTokenDto = {
  contactTitle?: ContactTitle | null
  firstName?: string | null
  lastName?: string | null
}

export type RejectionDto = {
  comment: string
}

export type CommentDto = {
  value: string
}

export type QuoteId = {
  id: string
}

export type QuoteRequestPostDto = {
  name: string
  items?: Array<ShortQuoteRequestItem> | null
}

export type ShortQuoteRequestItem = {
  productId?: number | null
  label?: string | null
  quantity?: number | null
}

export const AddToCartSuccess = {
  SUCCESS: 'SUCCESS',
  PARTIAL_SUCCESS: 'PARTIAL_SUCCESS',
  FAILURE: 'FAILURE'
} as const

export type AddToCartSuccess = (typeof AddToCartSuccess)[keyof typeof AddToCartSuccess]

export type SendPreparedOrderDto = {
  /**
   * Use ITscope-generated timestamp of the order you want to send
   */
  timestamp: string
}

export type RmaRequest = {
  positions: Array<RmaReturnPosition>
  comment: string
}

export type RmaReturnPosition = {
  orderLineItemId: string
  comment: string
}

export type RequestOrderPostDto = {
  /**
   * Comment which the approvers will see in the email
   */
  commentToApprovers?: string | null
}

export type OrderRejectionDto = {
  comment: string
}

export type ValidateOrderNumberDto = {
  /**
   * Order number that needs its uniqueness validated
   */
  orderNumber: string
}

export type ContactData = {
  firstName: string
  lastName: string
  email: string
  phone?: string | null
  phoneMobile?: string | null
}

export const Department = {
  SALES: 'Sales',
  PURCHASING: 'Purchasing',
  MARKETING: 'Marketing',
  SERVICE_SUPPORT: 'ServiceSupport',
  IT: 'IT',
  ACCOUNTING: 'Accounting',
  MANAGEMENT: 'Management',
  EXTERN: 'Extern',
  OTHER: 'Other',
  REGISTRATION_PENDING: 'RegistrationPending'
} as const

export type Department = (typeof Department)[keyof typeof Department]

export type OrderPostDto = {
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber?: string | null
  /**
   * End customer order id defined by the buyer
   */
  customerOrderId?: string | null
  billingAddress: ShopAddress
  deliveryAddress: ShopAddress
  orderComment?: string | null
  usePartialShipment?: boolean | null
  paymentMethod?: PaymentMethod | null
  billingContactData?: ContactData | null
  deliveryContactData?: ContactData | null
  /**
   * Use ITscope-generated timestamp of the order you want to update
   */
  timestamp: string
}

export const PaymentMethod = { INVOICE: 'INVOICE', CREDIT: 'CREDIT' } as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]

export type ShopAddress = {
  id: string
  companyName: string
  addition1?: string | null
  addition2?: string | null
  street: string
  zipCode: string
  city: string
  postBox?: string | null
  /**
   * Country code according to the ISO 3166-1 alpha 3 standard.
   */
  iso3country: string
  /**
   * Telephone number headed by country code.
   */
  phone?: string | null
  email: string
  clientNumber?: string | null
  url?: string | null
  /**
   * Flag that denotes whether this address is the primary address
   */
  isPrimaryAddress: boolean
  /**
   * Flag that denotes whether this address is the default billing address
   */
  isDefaultBillingAddress: boolean
  /**
   * Flag that denotes whether this address should be set as default delivery address
   */
  isDefaultDeliveryAddress: boolean
  /**
   * The portal user who created the address
   */
  user?: ShortUser | null
  /**
   * Flag that denotes whether the user is allowed to edit this address.
   */
  canEdit: boolean
}

export type ShortUser = {
  id: string
  avatarUrl?: string | null
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  department: Department
  userRegistered: boolean
  companyName: string
}

export type OrderResponse = {
  /**
   * ITscope generated order id
   */
  id: string
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber: string
}

export type ProposeOrderPostDto = {
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber?: string | null
  /**
   * End customer order id defined by the buyer
   */
  customerOrderId?: string | null
  billingAddress: ShopAddress
  deliveryAddress: ShopAddress
  orderComment?: string | null
  paymentMethod?: PaymentMethod | null
  /**
   * Comment which the approvers will see in the email
   */
  commentToApprovers?: string | null
  usePartialShipment: boolean
  billingContactData?: ContactData | null
  deliveryContactData?: ContactData | null
  /**
   * Use ITscope-generated timestamp of the order you want to update
   */
  timestamp: string
}

export type EmailPostDto = {
  email: string
}

export type SendCollectionPostDto = {
  emails: Array<string>
  subject: string | null
  withAttachment: boolean
}

export type EmailsPostDto = {
  emails: Array<string>
}

export type EmailsResponse = {
  invalidEmails: Array<string>
  isAlreadyRegistered: Array<string>
  isAlreadyInvited: Array<string>
  blacklistedEmails: Array<string>
  isValid: boolean
}

export type BaseModel = {
  baseModelPicUrl?: string | null
  description: string
  descriptionTwo: string
  manufacturerMaterialNo: string
  materialNo: string
  modelId: number
  ean: string
}

export type ModelComponent = {
  componentListPrice: number
  componentId: number
  description: string
}

export type ProductClassesPostDto = {
  baseModel: BaseModel
  modelComponents: Array<ModelComponent>
}

export type ArticleNumber = {
  ean?: string | null
  manufacturerProductId?: string | null
  additionalId?: string | null
}

export type MediumProduct = {
  productId: number
  title: string
  articleNumber: ArticleNumber
  imageUrl?: string | null
  /**
   * Can be null, and will be if quick=true
   */
  price?: SimplePrice | null
  /**
   * Can be null, and will be if quick=true
   */
  stock?: SimpleStock | null
  productType: ProductType
  description: Array<string>
  /**
   * Can be empty, and will be if quick=true
   */
  suppliers: Array<SupplierRow>
  condition?: Condition | null
  /**
   * This field is sunset since 28.07.2026.
   */
  conditionDescription?: string | null
  grading?: Grading | null
  isBundle: boolean
  hasEpeat?: boolean | null
  productFamily: ProductFamily
}

export const ProductFamily = {
  PHYSICAL: 'PHYSICAL',
  ESD: 'ESD',
  SERVICE: 'SERVICE',
  LICENSE: 'LICENSE',
  CTO: 'CTO',
  SPARE: 'SPARE'
} as const

export type ProductFamily = (typeof ProductFamily)[keyof typeof ProductFamily]

export type ProductType = {
  id: number
  name: string
}

export type CollectionName = {
  name: string
}

export type CollectionItemPostDto = {
  productId: number
}

export type CollectionId = {
  id: string
}

/**
 * Strategy of the features an optimization result should have
 */
export const OptimizationStrategy = {
  MANUAL: 'MANUAL',
  MINPRICE: 'MINPRICE',
  MINSUPPLIERS: 'MINSUPPLIERS',
  ADDITIONAL_SHOP_OPTIMIZATION: 'ADDITIONAL_SHOP_OPTIMIZATION'
} as const

/**
 * Strategy of the features an optimization result should have
 */
export type OptimizationStrategy = (typeof OptimizationStrategy)[keyof typeof OptimizationStrategy]

export type CartItemPostDto = {
  id?: string | null
  productId: number
  supplierRowId?: number | null
  quantity: number
}

export type CartItemMoveDto = {
  toSupplierCartId: string
}

export type ShopAddressDto = {
  companyName?: string | null
  addition1?: string | null
  addition2?: string | null
  street?: string | null
  zipCode?: string | null
  city?: string | null
  postBox?: string | null
  /**
   * Country code according to the ISO 3166-1 alpha 3 standard.
   */
  iso3country?: string | null
  /**
   * Telephone number headed by country code.
   */
  phone?: string | null
  email?: string | null
  clientNumber?: string | null
  url?: string | null
  /**
   * Flag that denotes whether this address should be set as default billing address
   */
  isDefaultBillingAddress?: boolean | null
  /**
   * Flag that denotes whether this address should be set as default delivery address
   */
  isDefaultDeliveryAddress?: boolean | null
}

export const AddressType = { BILLING: 'billing', DELIVERY: 'delivery' } as const

export type AddressType = (typeof AddressType)[keyof typeof AddressType]

export type CheckoutAddressValidation = {
  valid: boolean
  error?: string | null
}

export type UserPatchDto = {
  title?: ContactTitle | null
  firstName?: string | null
  lastName?: string | null
  /**
   * 2 letter language code according to ISO 639-1
   */
  alpha2language?: string | null
  department?: Department | null
  phoneMobile?: string | null
  phone?: string | null
}

export const ProductSearchView = { CARDS: 'CARDS', LIST: 'LIST' } as const

export type ProductSearchView = (typeof ProductSearchView)[keyof typeof ProductSearchView]

export type SettingPatch = {
  preferedProductSearchView?: ProductSearchView | null
  allowTracking?: boolean | null
}

export type PermissionPatch = {
  /**
   * Determines if this user has the right to order
   */
  submitOrder?: boolean | null
  shopAdmin?: boolean | null
  /**
   * Determines if this user has the right to switch subsidiaries
   */
  changeSubsidiary?: boolean | null
}

export type PasswordChangeDto = {
  currentPassword: string
  newPassword: string
}

export type QuoteUpdate = {
  buyerContact?: ContactData | null
  buyerAddress?: ShopAddress | null
  buyerAddressId?: string | null
  /**
   * Use ITscope-generated timestamp of the quote you want to update
   */
  timestamp: string
}

export type QuoteItemUpdate = {
  quantity?: number | null
  isPickedOptional?: boolean | null
  /**
   * Use ITscope-generated timestamp of the quote you want to update
   */
  timestamp: string
}

export type QuoteRequestPatch = {
  name?: string | null
  comment?: string | null
}

export type QuoteRequestItemDto = {
  quantity?: number | null
  comment?: string | null
}

export type UpdateOrderItemDto = {
  quantity?: number | null
  comment?: string | null
  sellerComment?: string | null
  /**
   * Use ITscope-generated timestamp of the order you want to update
   */
  timestamp: string
}

export type UpdateOrderPatchDto = {
  billingAddress?: ShopAddress | null
  deliveryAddress?: ShopAddress | null
  billingContactData?: ContactData | null
  deliveryContactData?: ContactData | null
  isArchived?: boolean | null
  hasPartialShipment?: boolean | null
  comment?: string | null
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber?: string | null
  customerOrderId?: string | null
  /**
   * Use ITscope-generated timestamp of the order you want to update
   */
  timestamp: string
}

export const OrderLimitType = {
  UNLIMITED: 'UNLIMITED',
  DEFAULT: 'DEFAULT',
  USER: 'USER'
} as const

export type OrderLimitType = (typeof OrderLimitType)[keyof typeof OrderLimitType]

export type OrderLimitUserPatch = {
  /**
   * Determines if this user has the right to order
   */
  submitOrder: boolean
  /**
   * User specific order limit
   */
  userOrderLimit?: number | null
  orderLimitType: OrderLimitType
  approverIds: Array<string>
}

export type DefaultOrderLimitPatch = {
  activated?: boolean | null
  /**
   * Company specific order limit
   */
  defaultOrderLimit?: number | null
  approverIds?: Array<string> | null
}

export type CollectionPatchDto = {
  name?: string | null
  description?: string | null
  assignedUserId?: string | null
}

export type CollectionItemPatchDto = {
  comment?: string | null
  quantity?: number | null
}

export type CartItemSellerComment = {
  field1?: string | null
  field2?: string | null
  field3?: string | null
  field4?: string | null
  field5?: string | null
  field6?: string | null
}

export type CartPatchDto = {
  quantity?: number | null
  supplierComment?: string | null
  sellerComments?: CartItemSellerComment | null
  /**
   * Use ITscope-generated timestamp of the cart you want to update
   */
  timestamp: string
}

export type Permission = {
  /**
   * Has the right to submit a prepared order. This right does not include the creation of orders, as this is a common right.
   */
  submitOrder: boolean
  /**
   * This is the limit of the order value which can be ordered without approval.
   */
  orderLimit?: number | null
  isApprover: boolean
  /**
   * The administrator has permission to alter the rights of other users including himself
   */
  shopAdmin: boolean
  /**
   * This gives the user the right to switch between subsidiaries
   */
  changeSubsidiary?: boolean | null
}

export type Setting = {
  preferedProductSearchView: ProductSearchView
  allowTracking: boolean
}

export type User = {
  id: string
  title: ContactTitle
  firstName: string
  lastName: string
  email: string
  /**
   * 2 letter language code according to ISO 639-1
   */
  alpha2language: string
  avatarUrl?: string | null
  companyName: string
  department: Department
  phoneMobile?: string | null
  phone?: string | null
  permission: Permission
  setting: Setting
}

export type AuthTokens = {
  refreshToken: string
  accessToken: string
}

export type Subsidiary = {
  id: string
  name: string
}

export type PageableResponseSubsidiary = {
  totalCount: number
  pageCount: number
  items: Array<Subsidiary>
}

export type ImpersonationStatus = {
  relation: Relation
  /**
   * Name of the portal owner
   */
  customer: string
}

export const Relation = {
  NONE: 'NONE',
  BRANCH: 'BRANCH',
  OWNER: 'OWNER'
} as const

export type Relation = (typeof Relation)[keyof typeof Relation]

export type ShortProduct = {
  productId: number
  title: string
  articleNumber: ArticleNumber
  imageUrl?: string | null
  price?: SimplePrice | null
  stock?: SimpleStock | null
  productType: ProductType
  condition?: Condition | null
}

export type StartPage = {
  startPageType: StartPageType
  /**
   * Custom set text to display. Can contain HTML.
   */
  htmlText?: string | null
  /**
   * List of featured products. Empty when individual or categories are shown.
   */
  featuredProducts: Array<ShortProduct>
}

export const StartPageType = {
  CATEGORIES: 'categories',
  INDIVIDUAL: 'individual',
  POPULAR: 'popular',
  PRODUCT_LIST: 'productList'
} as const

export type StartPageType = (typeof StartPageType)[keyof typeof StartPageType]

export const StorefrontProductSort = {
  RELEVANCE: 'RELEVANCE',
  POPULARITY: 'POPULARITY',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  CALC_PRICE_ASC: 'CALC_PRICE_ASC',
  CALC_PRICE_DESC: 'CALC_PRICE_DESC',
  AVAILABILITY: 'AVAILABILITY',
  STOCK: 'STOCK'
} as const

export type StorefrontProductSort =
  (typeof StorefrontProductSort)[keyof typeof StorefrontProductSort]

export type SliceMediumProduct = {
  items: Array<MediumProduct>
  hasNext: boolean
  lastKey: number
}

export type CustomTerms = {
  /**
   * True if custom terms apply
   */
  isCustomTerms: boolean
  /**
   * Custom terms can be defined on ITscope platform.
   */
  terms?: string | null
}

export const StorefrontQuoteSort = {
  DATE_ASC: 'DATE_ASC',
  DATE_DESC: 'DATE_DESC',
  VALID_ASC: 'VALID_ASC',
  VALID_DESC: 'VALID_DESC',
  LAST_MODIFIED: 'LAST_MODIFIED',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  ORGANISATION_ASC: 'ORGANISATION_ASC',
  ORGANISATION_DESC: 'ORGANISATION_DESC'
} as const

export type StorefrontQuoteSort = (typeof StorefrontQuoteSort)[keyof typeof StorefrontQuoteSort]

export type PageableResponseShortQuote = {
  totalCount: number
  pageCount: number
  items: Array<ShortQuote>
}

export const QuoteStatus = {
  DRAFT: 'DRAFT',
  NEGOTIATION: 'NEGOTIATION',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  REQUESTED: 'REQUESTED'
} as const

export type QuoteStatus = (typeof QuoteStatus)[keyof typeof QuoteStatus]

export type ShortQuote = {
  id: string
  name: string
  quoteNumber: string
  itemCount: number
  assignee?: ShortUser | null
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  createdDate: string
  /**
   * Sum of all item prices in the quote.
   */
  sum: Money
  quoteStatus: QuoteStatus
  /**
   * Flag indicates if user already viewed quote.
   */
  alreadyViewed: boolean
  /**
   * Flag indicates if buyer archived the quote.
   */
  buyerArchived: boolean
  /**
   * Flag indicates if price already includes taxes.
   */
  isGrossQuote: boolean
}

export type AddressSelection = {
  availableAddresses: Array<ShopAddress>
  canAdd: boolean
}

export type ContactUser = {
  firstName: string
  lastName: string
  email: string
  avatarUrl?: string | null
  phoneMobile?: string | null
  phone?: string | null
}

export type Discount = {
  value: Money
  percentual: boolean
}

export type FullQuote = {
  id: string
  name: string
  quoteNumber: string
  headerText?: string | null
  footerText?: string | null
  itemCount: number
  sellerUser?: ContactUser | null
  buyerAddress?: ShopAddress | null
  buyerAddressSelection?: AddressSelection | null
  buyerUser?: ContactUser | null
  /**
   * Customer number is assigned by the portal owner
   */
  buyerCustomerNumber?: string | null
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  createdDate: string
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  validDate?: string | null
  items: Array<QuoteItem>
  sumInformation: OrderSumInformation
  rejectionInformation?: RejectionInformation | null
  isArchived: boolean
  isGrossQuote: boolean
  alpha2language: string
  quoteVersion: string
}

export type OrderSumInformation = {
  netSum: Money
  grossSum: Money
  totalTaxes: Array<TotalTaxInfo>
  netDiscount?: Money | null
  netSumWithoutDiscount: Money
}

export type Quote = {
  id: string
  name: string
  quoteStatus: QuoteStatus
  request?: QuoteRequest | null
  quote?: FullQuote | null
  /**
   * Use ITscope-generated timestamp of the quote you want to update
   */
  timestamp: string
  orderId?: string | null
  quoteVersion: string
}

export type QuoteItem = {
  id: string
  productId?: number | null
  quantity: number
  productTitle: string
  productImageUrls: Array<string>
  price?: SimplePrice | null
  discount?: Discount | null
  totalPrice?: Money | null
  /**
   * Value added tax percentage e.g. 19 for germany
   */
  vatPercent?: number | null
  /**
   * Is this an optional item to be picked?
   */
  isOptional: boolean
  isQuantityEditCustomer: boolean
  /**
   * Optional item that is picked in the final quote.
   */
  isPickedOptional: boolean
  hasDatasheet: boolean
  isInShopAssortment: boolean
  uniqueId?: number
}

export type QuoteRequest = {
  id: string
  author: ShortUser
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  createdDate: string
  items: Array<QuoteItem>
  comment?: string | null
  sum: Money
}

export type RejectionInformation = {
  date: string
  rejectedByUser: ShortUser
  rejectionComment?: string | null
}

export type TotalTaxInfo = {
  /**
   * Value added tax percentage e.g. 19 for germany
   */
  vatPercent: number
  vatSum: Money
}

export type QuoteActivity = {
  id: string
  type: QuoteActivityType
  user: QuoteActivityUser
  message: string
  /**
   * Use ITscope-generated timestamp of the quote you want to update
   */
  timestamp: string
}

export const QuoteActivityType = { CHAT: 'CHAT', HISTORY: 'HISTORY' } as const

export type QuoteActivityType = (typeof QuoteActivityType)[keyof typeof QuoteActivityType]

export type QuoteActivityUser = {
  avatarUrl?: string | null
  fullName: string
}

export type ServerSentEventListQuoteActivity = unknown

export type NewQuotesCount = {
  count: number
}

export type FilterIdentifier = {
  name: string
  values: Array<FilterValue>
}

export type FilterValue = {
  name: string
  term: string
  count?: number | null
}

export type ServerSentEventQuote = unknown

export type QuoteRequestForProduct = {
  id: string
  name: string
  /**
   * Is true if the product is in the request.
   */
  hasProduct: boolean
}

export type PageableResponseMediumProduct = {
  totalCount: number
  pageCount: number
  items: Array<MediumProduct>
}

export type ChargerInfo = {
  /**
   * EU common charger pictogram indicating whether a charging device is included in the package
   */
  chargerIncludedUrl?: string | null
  /**
   * EU common charger label showing supported charging power range and USB Power Delivery capability
   */
  chargerInformationUrl?: string | null
}

export type Datasheet = {
  /**
   * URL to the manufacturer's datasheet
   */
  manufacturerUrl?: string | null
}

export type EpeatInfo = {
  /**
   * If this product is EPEAT certified
   */
  certified: boolean
  /**
   * Locale specific textual EPEAT level, e.g. 'EPEAT Gold', 'EPEAT Silver', 'EPEAT Bronze' or 'EPEAT Registered'
   */
  level?: string | null
}

export type EprelInfo = {
  /**
   * EPREL product badge from A -> G, e.g. https://eprel.ec.europa.eu/assets/images/label/thumbnails/D-Left-Yellow-WithAGScale.png
   */
  badgeUrl?: string | null
  /**
   * EPREL product specific label, e.g. https://eprel.ec.europa.eu/label/Label_123456.png
   */
  labelUrl?: string | null
  /**
   * EPREL product datasheet URL, e.g. https://eprel.ec.europa.eu/informationsheet/Fiche_123456_DE.pdf
   */
  datasheetUrl?: string | null
}

export type FullProduct = {
  productId: number
  manufacturer: Manufacturer
  productType: ProductType
  title: string
  articleNumber: ArticleNumber
  description: Array<string>
  datasheet: Datasheet
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  listedSince: string
  imageUrls: Array<string>
  isBundle: boolean
  manufacturerSuggestedRetailPrice?: Money | null
  price?: SimplePrice | null
  stock?: SimpleStock | null
  technicalDetails: Array<TechnicalDetail>
  productDescription: Array<TextContent>
  suppliers: Array<SupplierRow>
  condition?: Condition | null
  /**
   * This field is sunset since 28.07.2026.
   */
  conditionDescription?: string | null
  grading?: Grading | null
  /**
   * This field is sunset since 20.06.2026. Use labels.epeat.certified instead.
   */
  hasEpeat?: boolean | null
  productFamily: ProductFamily
  labels: Labels
}

export type Labels = {
  /**
   * Electronic Product Environmental Assessment Tool (EPEAT)
   */
  epeat: EpeatInfo
  /**
   * EU Common Charger labels
   */
  charger: ChargerInfo
  /**
   * European Product Registry for Energy Labelling (EPREL)
   */
  eprel: EprelInfo
}

export type Manufacturer = {
  id: number
  name: string
}

export type TechnicalDetail = {
  group: string
  name: string
  value: string
}

export type TextContent = {
  contentCategory: string
  value: string
}

export type ProductFilterResponse = {
  filterIdentifiers: Array<FilterIdentifier>
  attributeIdentifiers: Array<FilterIdentifier>
}

export type BundleItemProduct = {
  productId: number
  manufacturer: Manufacturer
  productType: ProductType
  title: string
  articleNumber: ArticleNumber
  description: Array<string>
  datasheet: Datasheet
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  listedSince: string
  imageUrls: Array<string>
  technicalDetails: Array<TechnicalDetail>
  productDescription: Array<TextContent>
  manufacturerSuggestedRetailPrice?: Money | null
  suppliers: Array<SupplierRow>
  productFamily: ProductFamily
}

export type BundleReference = {
  product: BundleItemProduct
  amount: number
}

export type AccessoryGroup = {
  groupName: string
  products: Array<MediumProduct>
}

export type AddressPermissions = {
  canCreate: boolean
  canSetDefaultBillingAddress: boolean
  canSetDefaultDeliveryAddress: boolean
}

export type CommentField = {
  label?: string | null
  required: boolean
}

export type PortalSettings = {
  addressPermissions: AddressPermissions
  /**
   * Flag indicates if prices include taxes.
   */
  grossPortal: boolean
  /**
   * Value added tax of the portal, e.g. 19 for germany.
   */
  vatRatePercent: number
  /**
   * Flag indicates if VAT rate is visible e.g. on the order page.
   */
  showVatRate: boolean
  /**
   * Flag indicates if suppliers are visible e.g. on the product page.
   */
  showSuppliers: boolean
  /**
   * Flag indicates if product IDs are visible, e.g. on the product page.
   */
  showProductIds: boolean
  /**
   * True, if this portal has the Apple CTO Finder activated
   */
  useAppleCtoFinder: boolean
  /**
   * Flag indicates if quotes are available. Can be changed on ITscope platform.
   */
  useQuotes: boolean
  /**
   * Flag indicates if users are only allowed to use their personally created addresses.
   */
  useOwnDeliveryAddress: boolean
  /**
   * Flag indicates if logout option is visible.
   */
  showLogout: boolean
  /**
   * Determines if every user sees his or her personal cart
   */
  isUserSpecificCartEnabled: boolean
  /**
   * Determines if every user sees only their collections
   */
  isUserSpecificCollectionsEnabled: boolean
  /**
   * Flag indicates if users may access the order limit options.
   */
  showOrderLimitFunctionality: boolean
  maxFileUploadSize?: string | null
  supplierComment: SupplierComments
  sellerComments: SellerComments
  /**
   * Flag indicates if the user may input an order number.
   */
  isCustomOrderNumberEnabled: boolean
  /**
   * Flag indicates if shipping costs are applied once per cart, independent of the number of supplier carts.
   */
  shippingCostsOnlyApplyOncePerCart: boolean
  /**
   * Flag indicates if minimum order surcharges are applied once per cart, independent of the number of supplier carts.
   */
  minimumOrderSurchargesOnlyApplyOncePerCart: boolean
  /**
   * The currency of the prices in the portal.
   */
  currency: string
}

export type SellerComments = {
  field1?: CommentField | null
  field2?: CommentField | null
  field3?: CommentField | null
  field4?: CommentField | null
  field5?: CommentField | null
  field6?: CommentField | null
}

export type SupplierComments = {
  field1: CommentField
}

export const StorefrontOrderSort = {
  SENT_DESC: 'SENT_DESC',
  SENT_ASC: 'SENT_ASC',
  LAST_MODIFIED: 'LAST_MODIFIED',
  SUPPLIER: 'SUPPLIER',
  ID: 'ID',
  CREATED_DESC: 'CREATED_DESC',
  STATUS_DESC: 'STATUS_DESC',
  STATUS_ASC: 'STATUS_ASC'
} as const

export type StorefrontOrderSort = (typeof StorefrontOrderSort)[keyof typeof StorefrontOrderSort]

export type Order = {
  /**
   * ITscope generated order id
   */
  id: string
  /**
   * Full name of user who initiated the order
   */
  initiatorFullName: string
  itemCount: number
  sum: Money
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber: string
  /**
   * Names of distributors used in this order. Is empty, if suppliers are not visible.
   */
  distributorNames: Array<string>
  lastUpdated: string
  sentDate?: string | null
  orderStatus: PortalOrderStatus
  isArchived: boolean
  isTopiOrder: boolean
}

export type PageableResponseOrder = {
  totalCount: number
  pageCount: number
  items: Array<Order>
}

export const PortalOrderStatus = {
  ADVISED: 'ADVISED',
  ARRIVED: 'ARRIVED',
  ARRIVED_WARNING: 'ARRIVED_WARNING',
  BLOCKED: 'BLOCKED',
  BLOCKED_BYLIMIT: 'BLOCKED_BYLIMIT',
  CANCELED: 'CANCELED',
  ERROR: 'ERROR',
  IN_TOPI_CHECKOUT: 'IN_TOPI_CHECKOUT',
  INVOICED: 'INVOICED',
  ORDERED_ELSEWHERE: 'ORDERED_ELSEWHERE',
  PARTIALLY_ADVISED: 'PARTIALLY_ADVISED',
  PARTIALLY_INVOICED: 'PARTIALLY_INVOICED',
  PARTIALLY_PROCESSING: 'PARTIALLY_PROCESSING',
  PAYMENT_AWAITING: 'PAYMENT_AWAITING',
  PAYMENT_SUCCESSFUL: 'PAYMENT_SUCCESSFUL',
  PENDING_TOPI_APPROVAL: 'PENDING_TOPI_APPROVAL',
  PORTAL_APPROVAL_DENIED: 'PORTAL_APPROVAL_DENIED',
  PREPARING: 'PREPARING',
  PROCESSING: 'PROCESSING',
  REJECTED: 'REJECTED',
  SENDING_ERROR: 'SENDING_ERROR',
  SENT: 'SENT',
  TOPI_DECLINED: 'TOPI_DECLINED',
  TOPI_EXPIRED: 'TOPI_EXPIRED',
  TRANSMITTING: 'TRANSMITTING'
} as const

export type PortalOrderStatus = (typeof PortalOrderStatus)[keyof typeof PortalOrderStatus]

export type ApprovalRequest = {
  /**
   * Date this request was created
   */
  createdDate: string
  /**
   * Date this request was processed by the processor
   */
  processedDate?: string | null
  /**
   * List of users who are assigned to approve this request
   */
  assignees: Array<ShortUser>
  /**
   * User who answered the request
   */
  processor?: ShortUser | null
  /**
   * Comment of the user who processed the request
   */
  processorComment?: string | null
  /**
   * Comment of the user who initiated the request
   */
  requestComment?: string | null
  /**
   * The current status of the request
   */
  status: ApprovalRequestStatus
}

export const ApprovalRequestStatus = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
} as const

export type ApprovalRequestStatus =
  (typeof ApprovalRequestStatus)[keyof typeof ApprovalRequestStatus]

export type Comment = {
  value?: string | null
  maxLength: number
}

export type DeliveryInfo = {
  carrier: string
  trackingLinks: Array<TrackingLink>
}

export type DetailedOrder = {
  /**
   * ITscope generated order id
   */
  id: string
  initiator: ShortUser
  itemCount: number
  orderSumInformation: OrderSumInformation
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber: string
  /**
   * End customer order id defined by the buyer
   */
  customerOrderId?: string | null
  distributorNames: Array<string>
  lastUpdated: string
  sentDate?: string | null
  orderStatus: PortalOrderStatus
  /**
   * Customer number is assigned by the portal owner
   */
  customerNumber: string
  deliveryAddress?: OrderAddress | null
  billingAddress: OrderAddress
  deliveryAddressSelection?: AddressSelection | null
  billingAddressSelection?: AddressSelection | null
  items: Array<OrderItem>
  shippingCost: Money
  orderLimitExceedance?: OrderLimitExceedance | null
  orderLimitValue?: Money | null
  orderLimitApprovers?: Array<ShortUser> | null
  quantitySurcharge?: Money | null
  isArchived: boolean
  orderComment?: string | null
  hasPartialShipment: boolean
  billingContactData?: ContactData | null
  deliveryContactData?: ContactData | null
  approvalRequest?: ApprovalRequest | null
  rmaInformation: OrderRmaInformation
  /**
   * ITscope-generated timestamp to be used for order updates
   */
  timestamp: string
  isTopiOrder: boolean
  topiCheckoutUrl?: string | null
  paymentMethod?: PaymentMethod | null
  validationStatus: OrderValidationStatus
}

export type OrderAddress = {
  companyName: string
  addition1?: string | null
  addition2?: string | null
  clientNumber?: string | null
  street: string
  /**
   * Country code according to the ISO 3166-1 alpha 3 standard.
   */
  iso3country: string
  zipCode: string
  city: string
  /**
   * Telephone number headed by country code.
   */
  phone?: string | null
  email?: string | null
  url?: string | null
}

export type OrderItem = {
  quantity: number
  supplierName: string
  productId?: number | null
  productTitle: string
  productImageUrl?: string | null
  price?: Money | null
  rawPrice?: Money | null
  totalPrice?: Money | null
  discount?: Discount | null
  articleNumber?: ArticleNumber | null
  subscriptionModel?: SubscriptionModel | null
  packagingModel?: PackagingModel | null
  comment: Comment
  sellerComment: Comment
  id: string
  serialNumbers: Array<SerialNumber>
  deliveryInfo?: DeliveryInfo | null
  isInAssortment: boolean
  rmaQuantity?: number | null
  orderStatus: PortalOrderStatus
}

export const OrderLimitExceedance = {
  KEPT: 'KEPT',
  NO_ORDER_RIGHT: 'NO_ORDER_RIGHT',
  EXCEEDED: 'EXCEEDED'
} as const

export type OrderLimitExceedance = (typeof OrderLimitExceedance)[keyof typeof OrderLimitExceedance]

export type OrderRmaInformation = {
  rmaPossible: boolean
  rmaAlreadyRequested: boolean
}

export const OrderValidationResult = {
  OK: 'OK',
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR'
} as const

export type OrderValidationResult =
  (typeof OrderValidationResult)[keyof typeof OrderValidationResult]

export type OrderValidationStatus = {
  infos: Array<string>
  warnings: Array<string>
  errors: Array<string>
  validationResult: OrderValidationResult
}

export type SerialNumber = {
  type?: string | null
  value: string
}

export type TrackingLink = {
  packageId: string
  url?: string | null
}

export type AvailableReturnPosition = {
  orderLineItemId: string
  productTitle: string
  productImageUrl?: string | null
  maxReturnQuantity: number
}

export type OrderRma = {
  returnReasons: Array<string>
  availableReturnPositions: Array<AvailableReturnPosition>
}

export type OrderTransaction = {
  id: string
  date: string
  transactionType: TransactionType
  documentNumber?: string | null
  status: PortalOrderStatus
  hasPdfDocument: boolean
}

export type OrderTransactions = {
  orderId: string
  transactions: Array<OrderTransaction>
}

export const TransactionType = {
  ORDER: 'ORDER',
  PAYMENT: 'PAYMENT',
  ORDERSTATUS: 'ORDERSTATUS',
  DELIVERY: 'DELIVERY',
  INVOICE: 'INVOICE'
} as const

export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType]

export type OrderSearchModel = {
  /**
   * ITscope generated order id
   */
  id: string
  initiatorFullName: string
  itemCount: number
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber: string
  lastUpdated: string
  orderStatus: PortalOrderStatus
}

export type OrderPreview = {
  /**
   * ITscope generated order id
   */
  id: string
  /**
   * User who initiated the order
   */
  initiatorUser: ShortUser
  orderSumInformation: OrderSumInformation
  /**
   * Names of distributors used in this order. Is empty, if suppliers are not visible.
   */
  distributorNames: Array<string>
  orderStatus: PortalOrderStatus
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber: string
  items: Array<OrderItem>
  shippingCost: Money
  sentDate?: string | null
  isTopiOrder: boolean
  timeStamp: string
}

export type PageableResponseOrderPreview = {
  totalCount: number
  pageCount: number
  items: Array<OrderPreview>
}

export type OrderLimitUser = {
  id: string
  avatarUrl?: string | null
  firstName: string
  lastName: string
  email?: string | null
  /**
   * Determines if this user has the right to order
   */
  submitOrder: boolean
  /**
   * User specific order limit
   */
  userOrderLimit?: number | null
  orderLimitType: OrderLimitType
  approvers: Array<ShortUser>
}

export type DefaultOrderLimit = {
  activated: boolean
  /**
   * Company specific order limit
   */
  companyOrderLimit?: number | null
  defaultApprovers: Array<ShortUser>
}

export type OrderingConditions = {
  /**
   * SUNSET since 4. Sept 2026: Flag indicates if Karla-Sofort-Payment is enabled, always false
   */
  isSofortPaymentEnabled: boolean
  isPartialShipmentEnabled: boolean
  /**
   * Flag indicates if customer order id should be shown
   */
  showCustomerOrderId: boolean
  /**
   * Flag indicates if the customer needs to enter ann order id to order
   */
  customerOrderIdRequired: boolean
  /**
   * Maximum length for comments
   */
  maxCommentLength: number
}

export type PunchoutForm = {
  payload: string
  eprocurementUrl: string
  target: string
  items: Array<PunchoutItem>
}

export type PunchoutItem = {
  puid: number
  displayName: string
  quantity: number
  priceForOne: Money
}

export type Attachment = {
  name: string
  content: string
  contentType: ContentType
}

export const ContentType = { PDF: 'PDF', XLS: 'XLS' } as const

export type ContentType = (typeof ContentType)[keyof typeof ContentType]

export type EmailPreview = {
  subject: string
  body: string
  attachments: Array<Attachment>
}

export type ProductClass = {
  productClassPicUrl: string
  productClassId: number
  ean: string
  productClassDescription: string
  materialNo: string
  manufacturerMaterialNo: string
}

export type ModelComponentGroup = {
  description: string
  groupId: number
  modelComponents: Array<SelectableModelComponent>
}

export type ModelConfiguration = {
  baseModel: BaseModel
  fixedModelComponents: Array<ModelComponent>
  modelComponentGroups: Array<ModelComponentGroup>
}

export type SelectableModelComponent = {
  componentListPrice: number
  componentId: number
  description: string
  selected: boolean
}

export type BaseModelResource = {
  baseModel: BaseModel
  selectedModelComponents: Array<ModelComponent>
}

export type ModelGroup = {
  productClassPicUrl: string
  modelGroupPicUrl: string
  modelGroupDescription: string
  modelParentGroupId: number
  modelGroupId: number
}

export type ModelGroupResource = {
  modelGroup: ModelGroup
  baseModels: Array<BaseModelResource>
}

export const StorefrontCollectionSort = {
  DATE_ASC: 'DATE_ASC',
  DATE_DESC: 'DATE_DESC',
  LAST_MODIFIED: 'LAST_MODIFIED',
  TITLE_DESC: 'TITLE_DESC',
  TITLE_ASC: 'TITLE_ASC'
} as const

export type StorefrontCollectionSort =
  (typeof StorefrontCollectionSort)[keyof typeof StorefrontCollectionSort]

export type PageableResponseShopCollection = {
  totalCount: number
  pageCount: number
  items: Array<ShopCollection>
}

export type ShopCollection = {
  id: string
  name: string
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  createdDate: string
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  lastModifiedDate?: string | null
  itemCount: number
  assignee?: ShortUser | null
  isArchived: boolean
}

export type CollectionItem = {
  id: string
  quantity: number
  productTitle?: string | null
  productImageUrl?: string | null
  comment?: string | null
  price?: SimplePrice | null
  stock?: SimpleStock | null
  productId: number
  articleNumber?: ArticleNumber | null
}

export type DetailedShopCollection = {
  id: string
  name: string
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  createdDate: string
  /**
   * Date in ISO-8601 format in UTC timezone
   */
  lastModifiedDate?: string | null
  assignee?: ShortUser | null
  description?: string | null
  isArchived: boolean
  items: Array<CollectionItem>
}

export type Checkout = {
  /**
   * Flag denoting if the order limit is exceeded
   */
  orderLimitExceedance: OrderLimitExceedance
  /**
   * List of users who can approve the order
   */
  orderLimitApprovers: Array<ShortUser> | null
  /**
   * Order limit, if available
   */
  orderLimitValue?: Money | null
  /**
   * Order number defined by the buyer or generated manually. Unique between buyer and seller.
   */
  orderNumber?: string | null
  /**
   * Customer number is assigned by the portal owner
   */
  customerNumber: string
  deliveryAddress: CheckoutAddress
  billingAddress: CheckoutAddress
}

export type CheckoutAddress = {
  default?: ShopAddress | null
  availableAddresses: Array<ShopAddress>
  canAdd: boolean
}

export type Category = {
  id: number
  /**
   * Term to be used as a filter in product search
   */
  searchTerm: string
  name: string
  /**
   * Is true if category has any own products or includes products of subcategories
   */
  isSelectable: boolean
  /**
   * List of subcategories
   */
  children: Array<Category>
}

export type Cart = {
  supplierCarts: Array<SupplierCart>
  cartInfo: CartInfo
  /**
   * ITscope-generated timestamp to be used for cart updates
   */
  timestamp: string
  /**
   * Denotes whether the user is allowed to order.
   */
  canOrder: Orderable
  /**
   * Explanations why ordering may be forbidden and other warnings for the user.
   */
  messages: Array<CartMessage>
}

export type CartInfo = {
  /**
   * Shopping cart total. Contains shipping and surcharge.
   */
  totalCost: Money
  /**
   * Sum of item costs, excluding shipping and surcharge.
   */
  itemCost: Money
  shippingCost?: Money | null
  totalTax: Money
  /**
   * Value added tax percentage e.g. 19 for germany
   */
  vatPercent: number
  /**
   * Surcharge for small quantities.
   */
  quantitySurcharge?: Money | null
}

export type CartItem = {
  id: string
  quantity: number
  productId: number
  articleNumber?: ArticleNumber | null
  productTitle?: string | null
  productImageUrl?: string | null
  supplierComment?: string | null
  sellerComments: CartItemSellerComment
  price?: SimplePrice | null
  stock?: SimpleStock | null
  condition?: Condition | null
}

export type CartMessage = {
  reason: CartMessageReason
  type: CartMessageLevel
  message: string
}

export const CartMessageLevel = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR'
} as const

export type CartMessageLevel = (typeof CartMessageLevel)[keyof typeof CartMessageLevel]

export const CartMessageReason = { MIN_ORDER_VALUE: 'MinOrderValue', OTHER: 'Other' } as const

export type CartMessageReason = (typeof CartMessageReason)[keyof typeof CartMessageReason]

export const Orderable = {
  FORBIDDEN: 'FORBIDDEN',
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED'
} as const

export type Orderable = (typeof Orderable)[keyof typeof Orderable]

export type SupplierCart = {
  id: string
  supplierName?: string | null
  cartItems: Array<CartItem>
  /**
   * Maximum length of comment for a cart item
   */
  maxPositionCommentLength: number
  cartInfo: CartInfo
  /**
   * Is it possible to order this supplier cart? Otherwise, the contents of this supplier cart an only be ordered by ordering the whole cart.
   */
  canOrder: Orderable
  /**
   * Explanations why ordering may be forbidden and other warnings for the user.
   */
  messages: Array<CartMessage>
  /**
   * ITscope-generated timestamp to be used for cart updates
   */
  timestamp: string
}

export type OptimizationType = {
  optimizationStrategy: OptimizationStrategy
  customName?: string | null
}

export type CartOptimizationResult = {
  optimizationStrategy: OptimizationStrategy
  /**
   * Total sum of cart for this optimization.
   */
  sum: Money
  /**
   * Difference in sum of optimized cart to the current cart.
   */
  difference: Money
}

export type CartItemMoveInfo = {
  /**
   * Maps each cart item serial to a list of available supplier cart serials where the item can be moved to
   */
  availableSupplierCarts: {
    [key: string]: Array<string>
  }
}

export type CartItemsCount = {
  count: number
}

export type Branding = {
  /**
   * True if this portal is currently paused e.g. due to maintenance
   */
  isPaused: boolean
  /**
   * Enables user login to portal
   */
  isLoginAllowed: boolean
  /**
   * Enables registration for new employees for an existing customer
   */
  isUserRegistration: boolean
  /**
   * Text shown when portal is paused
   */
  pausedText?: string | null
  ownerName: string
  portalName: string
  /**
   * Url to further legal info
   */
  legalInfoUrl?: string | null
  /**
   * Url to the terms and conditions
   */
  termsUrl?: string | null
  /**
   * Url to GDRR
   */
  privacyUrl?: string | null
  logoUrl?: string | null
  backgroundImageUrl?: string | null
  faviconUrl?: string | null
  primaryColorHexCode?: string | null
  ssoSettings?: SsoSettings | null
}

export type SsoSettings = {
  url: string
  ssoLoginExclusive: boolean
}

export type UploadAvatarData = {
  body?: {
    image: Blob | File
  }
  path: {
    id: string
  }
  query?: never
  url: '/storefront/user/{id}/avatar'
}

export type UploadAvatarErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Tried changing the avatar of a user other than yourself
   */
  403: string
  /**
   * File has unsupported MIME-Type
   */
  415: string
}

export type UploadAvatarError = UploadAvatarErrors[keyof UploadAvatarErrors]

export type ValidatePasswordChangeTokenData = {
  body: Token
  path?: never
  query?: never
  url: '/storefront/user/actions/validate-password-token'
}

export type ValidatePasswordChangeTokenErrors = {
  /**
   * The token is invalid
   */
  400: unknown
}

export type ValidatePasswordChangeTokenResponses = {
  /**
   * The token is valid
   */
  200: Token
}

export type ValidatePasswordChangeTokenResponse =
  ValidatePasswordChangeTokenResponses[keyof ValidatePasswordChangeTokenResponses]

export type InitiatePasswordResetData = {
  body: PasswordResetDto
  path?: never
  query?: never
  url: '/storefront/user/actions/reset-password'
}

export type InitiatePasswordResetErrors = {
  /**
   * Provided email is invalid
   */
  400: unknown
}

export type InitiatePasswordResetResponses = {
  /**
   * Password reset request has been processed
   */
  201: string
}

export type InitiatePasswordResetResponse =
  InitiatePasswordResetResponses[keyof InitiatePasswordResetResponses]

export type CreateLoginNetgoUserData = {
  body: string
  path?: never
  query?: never
  url: '/storefront/user/actions/netgo-login'
}

export type CreateLoginNetgoUserErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type CreateLoginNetgoUserError = CreateLoginNetgoUserErrors[keyof CreateLoginNetgoUserErrors]

export type CreateLoginNetgoUserResponses = {
  /**
   * OK
   */
  200: string
}

export type CreateLoginNetgoUserResponse =
  CreateLoginNetgoUserResponses[keyof CreateLoginNetgoUserResponses]

export type ChangePasswordData = {
  body: ChangePasswordDto
  path?: never
  query?: never
  url: '/storefront/user/actions/change-password'
}

export type ChangePasswordErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Password can not be changed due to invalid token
   */
  403: Token
}

export type ChangePasswordError = ChangePasswordErrors[keyof ChangePasswordErrors]

export type ChangePasswordResponses = {
  /**
   * Password has been changed
   */
  200: Token
}

export type ChangePasswordResponse = ChangePasswordResponses[keyof ChangePasswordResponses]

export type RuntimePricesData = {
  body: BatchRuntimeRequest
  path?: never
  query?: never
  url: '/storefront/runtime/products'
}

export type RuntimePricesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type RuntimePricesError = RuntimePricesErrors[keyof RuntimePricesErrors]

export type RuntimePricesResponses = {
  /**
   * OK
   */
  200: Array<BatchProductPriceUpdate>
}

export type RuntimePricesResponse = RuntimePricesResponses[keyof RuntimePricesResponses]

export type RuntimePriceData = {
  body: RuntimeRequest
  path?: never
  query?: never
  url: '/storefront/runtime/product'
}

export type RuntimePriceErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type RuntimePriceError = RuntimePriceErrors[keyof RuntimePriceErrors]

export type RuntimePriceResponses = {
  /**
   * OK
   */
  200: ProductPriceUpdate
}

export type RuntimePriceResponse = RuntimePriceResponses[keyof RuntimePriceResponses]

export type SelfRegisterData = {
  body: SelfRegistration
  path?: never
  query?: never
  url: '/storefront/registration'
}

export type SelfRegisterErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SelfRegisterError = SelfRegisterErrors[keyof SelfRegisterErrors]

export type SelfRegisterResponses = {
  /**
   * OK
   */
  200: string
}

export type SelfRegisterResponse = SelfRegisterResponses[keyof SelfRegisterResponses]

export type ValidateEmailsData = {
  body: Email
  path?: never
  query?: never
  url: '/storefront/registration/validate-mail'
}

export type ValidateEmailsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ValidateEmailsError = ValidateEmailsErrors[keyof ValidateEmailsErrors]

export type ValidateEmailsResponses = {
  /**
   * OK
   */
  200: EmailStatus
}

export type ValidateEmailsResponse = ValidateEmailsResponses[keyof ValidateEmailsResponses]

export type InviteYourselfData = {
  body: SelfInvite
  path?: never
  query?: never
  url: '/storefront/registration/self-invite'
}

export type InviteYourselfErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type InviteYourselfError = InviteYourselfErrors[keyof InviteYourselfErrors]

export type InviteYourselfResponses = {
  /**
   * OK
   */
  200: string
}

export type InviteYourselfResponse = InviteYourselfResponses[keyof InviteYourselfResponses]

export type RegisterInvitedUserData = {
  body: InvitationRegistration
  path?: never
  query?: never
  url: '/storefront/registration/invitation'
}

export type RegisterInvitedUserErrors = {
  /**
   * User has not been added due to invalid token or domain
   */
  400: unknown
}

export type RegisterInvitedUserResponses = {
  /**
   * User has been added
   */
  200: string
}

export type RegisterInvitedUserResponse =
  RegisterInvitedUserResponses[keyof RegisterInvitedUserResponses]

export type ValidateRegisterTokenData = {
  body: Token
  path?: never
  query?: never
  url: '/storefront/registration/invitation/validate-token'
}

export type ValidateRegisterTokenErrors = {
  /**
   * The token is invalid
   */
  400: unknown
}

export type ValidateRegisterTokenResponses = {
  /**
   * The token is valid
   */
  200: ValidTokenDto
}

export type ValidateRegisterTokenResponse =
  ValidateRegisterTokenResponses[keyof ValidateRegisterTokenResponses]

export type RejectQuoteData = {
  body?: RejectionDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes/{id}/reject'
}

export type RejectQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: string
}

export type RejectQuoteError = RejectQuoteErrors[keyof RejectQuoteErrors]

export type GetActivityData = {
  body?: never
  headers: {
    Authorization: string
  }
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes/{id}/activity'
}

export type GetActivityErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: Array<QuoteActivity>
}

export type GetActivityError = GetActivityErrors[keyof GetActivityErrors]

export type PostActivityData = {
  body: CommentDto
  headers: {
    Authorization: string
  }
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes/{id}/activity'
}

export type PostActivityErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: unknown
}

export type PostActivityError = PostActivityErrors[keyof PostActivityErrors]

export type DearchiveQuoteData = {
  body: QuoteId
  path?: never
  query?: never
  url: '/storefront/quotes/actions/dearchive'
}

export type DearchiveQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type DearchiveQuoteError = DearchiveQuoteErrors[keyof DearchiveQuoteErrors]

export type DearchiveQuoteResponses = {
  /**
   * OK
   */
  200: string
}

export type DearchiveQuoteResponse = DearchiveQuoteResponses[keyof DearchiveQuoteResponses]

export type ArchiveQuoteData = {
  body: QuoteId
  path?: never
  query?: never
  url: '/storefront/quotes/actions/archive'
}

export type ArchiveQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ArchiveQuoteError = ArchiveQuoteErrors[keyof ArchiveQuoteErrors]

export type ArchiveQuoteResponses = {
  /**
   * OK
   */
  200: string
}

export type ArchiveQuoteResponse = ArchiveQuoteResponses[keyof ArchiveQuoteResponses]

export type CreateQuoteRequestData = {
  body: QuoteRequestPostDto
  path?: never
  query?: never
  url: '/storefront/quote-requests'
}

export type CreateQuoteRequestErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type CreateQuoteRequestError = CreateQuoteRequestErrors[keyof CreateQuoteRequestErrors]

export type CreateQuoteRequestResponses = {
  /**
   * OK
   */
  200: string
}

export type CreateQuoteRequestResponse =
  CreateQuoteRequestResponses[keyof CreateQuoteRequestResponses]

export type DeleteQuoteRequestData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quote-requests/{id}'
}

export type DeleteQuoteRequestErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type DeleteQuoteRequestError = DeleteQuoteRequestErrors[keyof DeleteQuoteRequestErrors]

export type DeleteQuoteRequestResponses = {
  /**
   * OK
   */
  200: string
}

export type DeleteQuoteRequestResponse =
  DeleteQuoteRequestResponses[keyof DeleteQuoteRequestResponses]

export type GetQuoteRequestData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quote-requests/{id}'
}

export type GetQuoteRequestErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetQuoteRequestError = GetQuoteRequestErrors[keyof GetQuoteRequestErrors]

export type GetQuoteRequestResponses = {
  /**
   * OK
   */
  200: QuoteRequest
}

export type GetQuoteRequestResponse = GetQuoteRequestResponses[keyof GetQuoteRequestResponses]

export type UpdateQuoteRequestData = {
  body: QuoteRequestPatch
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quote-requests/{id}'
}

export type UpdateQuoteRequestErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type UpdateQuoteRequestError = UpdateQuoteRequestErrors[keyof UpdateQuoteRequestErrors]

export type UpdateQuoteRequestResponses = {
  /**
   * OK
   */
  200: string
}

export type UpdateQuoteRequestResponse =
  UpdateQuoteRequestResponses[keyof UpdateQuoteRequestResponses]

export type AddQuoteLineItemData = {
  body: ShortQuoteRequestItem
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quote-requests/{id}'
}

export type AddQuoteLineItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type AddQuoteLineItemError = AddQuoteLineItemErrors[keyof AddQuoteLineItemErrors]

export type AddQuoteLineItemResponses = {
  /**
   * OK
   */
  200: string
}

export type AddQuoteLineItemResponse = AddQuoteLineItemResponses[keyof AddQuoteLineItemResponses]

export type SendQuoteRequestData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quote-requests/{id}/send'
}

export type SendQuoteRequestErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SendQuoteRequestError = SendQuoteRequestErrors[keyof SendQuoteRequestErrors]

export type SendQuoteRequestResponses = {
  /**
   * OK
   */
  200: string
}

export type SendQuoteRequestResponse = SendQuoteRequestResponses[keyof SendQuoteRequestResponses]

export type AddOrderToCartData = {
  body?: never
  path: {
    orderId: string
  }
  query?: never
  url: '/storefront/orders/{orderId}/to-cart'
}

export type AddOrderToCartErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type AddOrderToCartError = AddOrderToCartErrors[keyof AddOrderToCartErrors]

export type AddOrderToCartResponses = {
  /**
   * OK
   */
  200: AddToCartSuccess
}

export type AddOrderToCartResponse = AddOrderToCartResponses[keyof AddOrderToCartResponses]

export type ApproveOrderData = {
  body: SendPreparedOrderDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}/send'
}

export type ApproveOrderErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No order permission or limit exceeded
   */
  403: string
}

export type ApproveOrderError = ApproveOrderErrors[keyof ApproveOrderErrors]

export type GetOrderRmaData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}/rma'
}

export type GetOrderRmaErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find order for provided id
   */
  404: OrderRma
  /**
   * User is in wrong company to access this order
   */
  412: OrderRma
}

export type GetOrderRmaError = GetOrderRmaErrors[keyof GetOrderRmaErrors]

export type CreateOrderRmaData = {
  body: RmaRequest
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}/rma'
}

export type CreateOrderRmaErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find order for provided id
   */
  404: string
  /**
   * User is in wrong company to access this order
   */
  412: string
}

export type CreateOrderRmaError = CreateOrderRmaErrors[keyof CreateOrderRmaErrors]

export type RequestOrderByIdData = {
  body: RequestOrderPostDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}/request'
}

export type RequestOrderByIdErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Order permission available with no limit exceeded.
   */
  403: string
}

export type RequestOrderByIdError = RequestOrderByIdErrors[keyof RequestOrderByIdErrors]

export type RejectOrderData = {
  body?: OrderRejectionDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}/reject'
}

export type RejectOrderErrors = {
  /**
   * No order permission or limit exceeded
   */
  400: unknown
  /**
   * No order permission or limit exceeded
   */
  403: string
}

export type RejectOrderError = RejectOrderErrors[keyof RejectOrderErrors]

export type ValidateOrderNumberData = {
  body: ValidateOrderNumberDto
  path?: never
  query?: never
  url: '/storefront/orders/validate'
}

export type ValidateOrderNumberErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ValidateOrderNumberError = ValidateOrderNumberErrors[keyof ValidateOrderNumberErrors]

export type ValidateOrderNumberResponses = {
  /**
   * OK
   */
  200: boolean
}

export type ValidateOrderNumberResponse =
  ValidateOrderNumberResponses[keyof ValidateOrderNumberResponses]

export type SendQuoteData = {
  body: OrderPostDto
  path?: never
  query: {
    quoteId: string
  }
  url: '/storefront/order/actions/send-quote'
}

export type SendQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No order permission
   */
  403: OrderResponse
  /**
   * Order already created (duplicate request)
   */
  409: OrderResponse
}

export type SendQuoteError = SendQuoteErrors[keyof SendQuoteErrors]

export type SendCartData = {
  body: OrderPostDto
  path?: never
  query?: {
    supplierCartId?: string
  }
  url: '/storefront/order/actions/send-cart'
}

export type SendCartErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No order permission
   */
  403: OrderResponse
  /**
   * Cart is not up to date
   */
  409: OrderResponse
}

export type SendCartError = SendCartErrors[keyof SendCartErrors]

export type SendCartTopiData = {
  body: OrderPostDto
  path?: never
  query?: {
    supplierCartId?: string
  }
  url: '/storefront/order/actions/send-cart-topi'
}

export type SendCartTopiErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SendCartTopiError = SendCartTopiErrors[keyof SendCartTopiErrors]

export type SendCartTopiResponses = {
  /**
   * OK
   */
  200: string
}

export type SendCartTopiResponse = SendCartTopiResponses[keyof SendCartTopiResponses]

export type RequestQuoteData = {
  body: ProposeOrderPostDto
  path?: never
  query: {
    quoteId: string
  }
  url: '/storefront/order/actions/request-quote'
}

export type RequestQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Order permission available with no limit exceeded
   */
  403: OrderResponse
}

export type RequestQuoteError = RequestQuoteErrors[keyof RequestQuoteErrors]

export type RequestCartData = {
  body: ProposeOrderPostDto
  path?: never
  query?: {
    supplierCartId?: string
  }
  url: '/storefront/order/actions/request-cart'
}

export type RequestCartErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Order permission available with no limit exceeded
   */
  403: OrderResponse
}

export type RequestCartError = RequestCartErrors[keyof RequestCartErrors]

export type ValidateEmails1Data = {
  body: EmailPostDto
  path?: never
  query?: never
  url: '/storefront/emails/validate'
}

export type ValidateEmails1Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ValidateEmails1Error = ValidateEmails1Errors[keyof ValidateEmails1Errors]

export type ValidateEmails1Responses = {
  /**
   * OK
   */
  200: EmailStatus
}

export type ValidateEmails1Response = ValidateEmails1Responses[keyof ValidateEmails1Responses]

export type GetSendCollectionMailData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/emails/send-collection/{id}'
}

export type GetSendCollectionMailErrors = {
  /**
   * No collection found for id
   */
  400: unknown
}

export type GetSendCollectionMailResponses = {
  /**
   * OK
   */
  200: EmailPreview
}

export type GetSendCollectionMailResponse =
  GetSendCollectionMailResponses[keyof GetSendCollectionMailResponses]

export type SendCollectionMailData = {
  body: SendCollectionPostDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/emails/send-collection/{id}'
}

export type SendCollectionMailErrors = {
  /**
   * No collection found for id
   */
  400: unknown
}

export type SendCollectionMailResponses = {
  /**
   * OK
   */
  200: string
}

export type SendCollectionMailResponse =
  SendCollectionMailResponses[keyof SendCollectionMailResponses]

export type GetProductRequestMailData = {
  body?: never
  path: {
    id: number
  }
  query?: never
  url: '/storefront/emails/request-product/{id}'
}

export type GetProductRequestMailErrors = {
  /**
   * No product found for id
   */
  400: unknown
}

export type GetProductRequestMailResponses = {
  /**
   * OK
   */
  200: EmailPreview
}

export type GetProductRequestMailResponse =
  GetProductRequestMailResponses[keyof GetProductRequestMailResponses]

export type SendProductRequestMailData = {
  body?: never
  path: {
    id: number
  }
  query?: never
  url: '/storefront/emails/request-product/{id}'
}

export type SendProductRequestMailErrors = {
  /**
   * Failed to send email
   */
  400: unknown
}

export type SendProductRequestMailResponses = {
  /**
   * OK
   */
  200: string
}

export type SendProductRequestMailResponse =
  SendProductRequestMailResponses[keyof SendProductRequestMailResponses]

export type InviteColleaguesData = {
  body: EmailsPostDto
  path?: never
  query?: never
  url: '/storefront/emails/invite'
}

export type InviteColleaguesErrors = {
  /**
   * Invalid, invited or already used emails in request
   */
  400: unknown
}

export type InviteColleaguesResponses = {
  /**
   * OK
   */
  200: EmailsResponse
}

export type InviteColleaguesResponse = InviteColleaguesResponses[keyof InviteColleaguesResponses]

export type GetProductInformationData = {
  body: ProductClassesPostDto
  path?: never
  query?: never
  url: '/storefront/cto/productinformation'
}

export type GetProductInformationErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetProductInformationError =
  GetProductInformationErrors[keyof GetProductInformationErrors]

export type GetProductInformationResponses = {
  /**
   * OK
   */
  200: MediumProduct
}

export type GetProductInformationResponse =
  GetProductInformationResponses[keyof GetProductInformationResponses]

export type GetCollectionsData = {
  body?: never
  path?: never
  query?: {
    filter?: string
    search?: string
    /**
     * Results page you want to retrieve (0..N)
     */
    page?: number
    /**
     * Number of records per page.
     */
    size?: number
    /**
     * DATE_ASC = Sent date ascending, DATE_DESC = Sent date descending, LAST_MODIFIED = Last modified date descending, TITLE_ASC = Title ascending, TITLE_DESC = Title descending
     */
    sort?: StorefrontCollectionSort
  }
  url: '/storefront/collections'
}

export type GetCollectionsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCollectionsError = GetCollectionsErrors[keyof GetCollectionsErrors]

export type GetCollectionsResponses = {
  /**
   * OK
   */
  200: PageableResponseShopCollection
}

export type GetCollectionsResponse = GetCollectionsResponses[keyof GetCollectionsResponses]

export type CreateCollectionData = {
  body: CollectionName
  path?: never
  query?: never
  url: '/storefront/collections'
}

export type CreateCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type CreateCollectionError = CreateCollectionErrors[keyof CreateCollectionErrors]

export type CreateCollectionResponses = {
  /**
   * OK
   */
  200: string
}

export type CreateCollectionResponse = CreateCollectionResponses[keyof CreateCollectionResponses]

export type DeleteCollectionData = {
  body?: never
  path: {
    collectionId: string
  }
  query?: never
  url: '/storefront/collections/{collectionId}'
}

export type DeleteCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type DeleteCollectionError = DeleteCollectionErrors[keyof DeleteCollectionErrors]

export type DeleteCollectionResponses = {
  /**
   * OK
   */
  200: unknown
}

export type GetCollectionData = {
  body?: never
  path: {
    collectionId: CollectionId
  }
  query?: never
  url: '/storefront/collections/{collectionId}'
}

export type GetCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCollectionError = GetCollectionErrors[keyof GetCollectionErrors]

export type GetCollectionResponses = {
  /**
   * OK
   */
  200: DetailedShopCollection
}

export type GetCollectionResponse = GetCollectionResponses[keyof GetCollectionResponses]

export type UpdateCollectionData = {
  body: CollectionPatchDto
  path: {
    collectionId: string
  }
  query?: never
  url: '/storefront/collections/{collectionId}'
}

export type UpdateCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find a collection for the provided id
   */
  404: string
}

export type UpdateCollectionError = UpdateCollectionErrors[keyof UpdateCollectionErrors]

export type AddToCollectionData = {
  body: CollectionItemPostDto
  path: {
    collectionId: string
  }
  query?: never
  url: '/storefront/collections/{collectionId}'
}

export type AddToCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type AddToCollectionError = AddToCollectionErrors[keyof AddToCollectionErrors]

export type AddToCollectionResponses = {
  /**
   * OK
   */
  200: string
}

export type AddToCollectionResponse = AddToCollectionResponses[keyof AddToCollectionResponses]

export type AddCollectionToCartData = {
  body: CollectionId
  path?: never
  query?: never
  url: '/storefront/collections/actions/to-cart'
}

export type AddCollectionToCartErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type AddCollectionToCartError = AddCollectionToCartErrors[keyof AddCollectionToCartErrors]

export type AddCollectionToCartResponses = {
  /**
   * OK
   */
  200: AddToCartSuccess
}

export type AddCollectionToCartResponse =
  AddCollectionToCartResponses[keyof AddCollectionToCartResponses]

export type RequestQuote2Data = {
  body: CollectionId
  path?: never
  query?: never
  url: '/storefront/collections/actions/request-quote'
}

export type RequestQuote2Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type RequestQuote2Error = RequestQuote2Errors[keyof RequestQuote2Errors]

export type RequestQuote2Responses = {
  /**
   * OK
   */
  200: string
}

export type RequestQuote2Response = RequestQuote2Responses[keyof RequestQuote2Responses]

export type DuplicateCollectionData = {
  body: CollectionId
  path?: never
  query?: never
  url: '/storefront/collections/actions/duplicate'
}

export type DuplicateCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type DuplicateCollectionError = DuplicateCollectionErrors[keyof DuplicateCollectionErrors]

export type DuplicateCollectionResponses = {
  /**
   * OK
   */
  200: string
}

export type DuplicateCollectionResponse =
  DuplicateCollectionResponses[keyof DuplicateCollectionResponses]

export type DearchiveCollectionData = {
  body: CollectionId
  path?: never
  query?: never
  url: '/storefront/collections/actions/dearchive'
}

export type DearchiveCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type DearchiveCollectionError = DearchiveCollectionErrors[keyof DearchiveCollectionErrors]

export type DearchiveCollectionResponses = {
  /**
   * OK
   */
  200: string
}

export type DearchiveCollectionResponse =
  DearchiveCollectionResponses[keyof DearchiveCollectionResponses]

export type ArchiveCollectionData = {
  body: CollectionId
  path?: never
  query?: never
  url: '/storefront/collections/actions/archive'
}

export type ArchiveCollectionErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ArchiveCollectionError = ArchiveCollectionErrors[keyof ArchiveCollectionErrors]

export type ArchiveCollectionResponses = {
  /**
   * OK
   */
  200: string
}

export type ArchiveCollectionResponse = ArchiveCollectionResponses[keyof ArchiveCollectionResponses]

export type OptimizeCartData = {
  body?: never
  path?: never
  query: {
    strategy: OptimizationStrategy
  }
  url: '/storefront/carts/optimizations/apply'
}

export type OptimizeCartErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type OptimizeCartError = OptimizeCartErrors[keyof OptimizeCartErrors]

export type OptimizeCartResponses = {
  /**
   * OK
   */
  200: string
}

export type OptimizeCartResponse = OptimizeCartResponses[keyof OptimizeCartResponses]

export type CreateLineItemData = {
  body: CartItemPostDto
  path?: never
  query?: never
  url: '/storefront/carts/items'
}

export type CreateLineItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type CreateLineItemError = CreateLineItemErrors[keyof CreateLineItemErrors]

export type CreateLineItemResponses = {
  /**
   * OK
   */
  200: string
}

export type CreateLineItemResponse = CreateLineItemResponses[keyof CreateLineItemResponses]

export type MoveLineItemData = {
  body: CartItemMoveDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/carts/items/{id}/move'
}

export type MoveLineItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * The item could not be moved to new supplier, because the supplier doesn't offer it.
   */
  409: string
}

export type MoveLineItemError = MoveLineItemErrors[keyof MoveLineItemErrors]

export type RequestQuote1Data = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/carts/actions/request-quote'
}

export type RequestQuote1Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type RequestQuote1Error = RequestQuote1Errors[keyof RequestQuote1Errors]

export type RequestQuote1Responses = {
  /**
   * OK
   */
  200: string
}

export type RequestQuote1Response = RequestQuote1Responses[keyof RequestQuote1Responses]

export type EmptyCartData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/carts/actions/empty'
}

export type EmptyCartErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type EmptyCartError = EmptyCartErrors[keyof EmptyCartErrors]

export type EmptyCartResponses = {
  /**
   * OK
   */
  200: string
}

export type EmptyCartResponse = EmptyCartResponses[keyof EmptyCartResponses]

export type ReadAddressesData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/addresses'
}

export type ReadAddressesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ReadAddressesError = ReadAddressesErrors[keyof ReadAddressesErrors]

export type ReadAddressesResponses = {
  /**
   * OK
   */
  200: Array<ShopAddress>
}

export type ReadAddressesResponse = ReadAddressesResponses[keyof ReadAddressesResponses]

export type CreateAddressData = {
  body: ShopAddressDto
  path?: never
  query?: never
  url: '/storefront/addresses'
}

export type CreateAddressErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Tried creating a primary address. This cannot be achieved by API, only on the ITscope plattform.
   */
  403: ShopAddress
}

export type CreateAddressError = CreateAddressErrors[keyof CreateAddressErrors]

export type ValidateAddressCheckoutData = {
  body: ShopAddress
  path: {
    type: AddressType
  }
  query?: never
  url: '/storefront/addresses/validate/{type}'
}

export type ValidateAddressCheckoutErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ValidateAddressCheckoutError =
  ValidateAddressCheckoutErrors[keyof ValidateAddressCheckoutErrors]

export type ValidateAddressCheckoutResponses = {
  /**
   * OK
   */
  200: CheckoutAddressValidation
}

export type ValidateAddressCheckoutResponse =
  ValidateAddressCheckoutResponses[keyof ValidateAddressCheckoutResponses]

export type UpdateUserData = {
  body: UserPatchDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/user/{id}'
}

export type UpdateUserErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Tried updating a user other than yourself
   */
  403: string
}

export type UpdateUserError = UpdateUserErrors[keyof UpdateUserErrors]

export type UpdateUserSettingsData = {
  body: SettingPatch
  path: {
    id: string
  }
  query?: never
  url: '/storefront/user/{id}/setting'
}

export type UpdateUserSettingsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type UpdateUserSettingsError = UpdateUserSettingsErrors[keyof UpdateUserSettingsErrors]

export type UpdateUserSettingsResponses = {
  /**
   * OK
   */
  200: string
}

export type UpdateUserSettingsResponse =
  UpdateUserSettingsResponses[keyof UpdateUserSettingsResponses]

export type UpdateUserPermissionsData = {
  body: PermissionPatch
  path: {
    id: string
  }
  query?: never
  url: '/storefront/user/{id}/permission'
}

export type UpdateUserPermissionsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Tried updating permissions without having the admin permission
   */
  403: string
}

export type UpdateUserPermissionsError =
  UpdateUserPermissionsErrors[keyof UpdateUserPermissionsErrors]

export type UpdateUserCredentialsData = {
  body: PasswordChangeDto
  path?: never
  query?: never
  url: '/storefront/user/me/credentials'
}

export type UpdateUserCredentialsErrors = {
  /**
   * Tried updating credentials without having a proper new password
   */
  400: unknown
  /**
   * Tried updating permissions without having the proper old password
   */
  403: string
}

export type UpdateUserCredentialsError =
  UpdateUserCredentialsErrors[keyof UpdateUserCredentialsErrors]

export type LoadQuoteByIdData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes/{id}'
}

export type LoadQuoteByIdErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: Quote
}

export type LoadQuoteByIdError = LoadQuoteByIdErrors[keyof LoadQuoteByIdErrors]

export type UpdateQuoteData = {
  body: QuoteUpdate
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes/{id}'
}

export type UpdateQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find quote with id
   */
  404: string
}

export type UpdateQuoteError = UpdateQuoteErrors[keyof UpdateQuoteErrors]

export type UpdateQuoteItemData = {
  body: QuoteItemUpdate
  path: {
    id: string
    itemId: string
  }
  query?: never
  url: '/storefront/quotes/{id}/items/{itemId}'
}

export type UpdateQuoteItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find quote with id or item with itemId
   */
  404: string
}

export type UpdateQuoteItemError = UpdateQuoteItemErrors[keyof UpdateQuoteItemErrors]

export type DeleteLineItemData = {
  body?: never
  path: {
    id: string
    itemId: string
  }
  query?: never
  url: '/storefront/quote-requests/{id}/items/{itemId}'
}

export type DeleteLineItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find a quote or item for the provided id
   */
  404: string
}

export type DeleteLineItemError = DeleteLineItemErrors[keyof DeleteLineItemErrors]

export type UpdateLineItemData = {
  body: QuoteRequestItemDto
  path: {
    id: string
    itemId: string
  }
  query?: never
  url: '/storefront/quote-requests/{id}/items/{itemId}'
}

export type UpdateLineItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find a quote or item for the provided id
   */
  404: string
}

export type UpdateLineItemError = UpdateLineItemErrors[keyof UpdateLineItemErrors]

export type DeleteOrderItemData = {
  body?: never
  path: {
    orderId: string
    itemId: string
  }
  query?: never
  url: '/storefront/orders/{orderId}/items/{itemId}'
}

export type DeleteOrderItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find order item for provided ids
   */
  404: string
}

export type DeleteOrderItemError = DeleteOrderItemErrors[keyof DeleteOrderItemErrors]

export type PatchOrderItemData = {
  body: UpdateOrderItemDto
  path: {
    orderId: string
    itemId: string
  }
  query?: never
  url: '/storefront/orders/{orderId}/items/{itemId}'
}

export type PatchOrderItemErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find order item for provided ids
   */
  404: string
}

export type PatchOrderItemError = PatchOrderItemErrors[keyof PatchOrderItemErrors]

export type UpdateOrderData = {
  body: UpdateOrderPatchDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}'
}

export type UpdateOrderErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find order for provided id
   */
  404: string
}

export type UpdateOrderError = UpdateOrderErrors[keyof UpdateOrderErrors]

export type UpdateOrderLimitUserData = {
  body: OrderLimitUserPatch
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/limits/users/{id}'
}

export type UpdateOrderLimitUserErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type UpdateOrderLimitUserError = UpdateOrderLimitUserErrors[keyof UpdateOrderLimitUserErrors]

export type UpdateOrderLimitUserResponses = {
  /**
   * OK
   */
  200: string
}

export type UpdateOrderLimitUserResponse =
  UpdateOrderLimitUserResponses[keyof UpdateOrderLimitUserResponses]

export type ReadCompanyOrderLimitData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/orders/limits/company'
}

export type ReadCompanyOrderLimitErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ReadCompanyOrderLimitError =
  ReadCompanyOrderLimitErrors[keyof ReadCompanyOrderLimitErrors]

export type ReadCompanyOrderLimitResponses = {
  /**
   * OK
   */
  200: DefaultOrderLimit
}

export type ReadCompanyOrderLimitResponse =
  ReadCompanyOrderLimitResponses[keyof ReadCompanyOrderLimitResponses]

export type UpdateCompanyOrderLimitData = {
  body: DefaultOrderLimitPatch
  path?: never
  query?: never
  url: '/storefront/orders/limits/company'
}

export type UpdateCompanyOrderLimitErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type UpdateCompanyOrderLimitError =
  UpdateCompanyOrderLimitErrors[keyof UpdateCompanyOrderLimitErrors]

export type UpdateCompanyOrderLimitResponses = {
  /**
   * OK
   */
  200: string
}

export type UpdateCompanyOrderLimitResponse =
  UpdateCompanyOrderLimitResponses[keyof UpdateCompanyOrderLimitResponses]

export type DeleteLineItem1Data = {
  body?: never
  path: {
    collectionId: string
    itemId: number
  }
  query?: never
  url: '/storefront/collections/{collectionId}/items/{itemId}'
}

export type DeleteLineItem1Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find a collection or item for the provided id
   */
  404: string
}

export type DeleteLineItem1Error = DeleteLineItem1Errors[keyof DeleteLineItem1Errors]

export type UpdateLineItem1Data = {
  body: CollectionItemPatchDto
  path: {
    collectionId: string
    itemId: number
  }
  query?: never
  url: '/storefront/collections/{collectionId}/items/{itemId}'
}

export type UpdateLineItem1Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find a collection or item for the provided id
   */
  404: string
}

export type UpdateLineItem1Error = UpdateLineItem1Errors[keyof UpdateLineItem1Errors]

export type DeleteLineItem2Data = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/carts/items/{id}'
}

export type DeleteLineItem2Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find a cart item for the provided id
   */
  404: string
}

export type DeleteLineItem2Error = DeleteLineItem2Errors[keyof DeleteLineItem2Errors]

export type UpdateLineItem2Data = {
  body: CartPatchDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/carts/items/{id}'
}

export type UpdateLineItem2Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find a cart item for the provided id
   */
  404: string
}

export type UpdateLineItem2Error = UpdateLineItem2Errors[keyof UpdateLineItem2Errors]

export type UpdateLineItem2Responses = {
  /**
   * New cart timestamp
   */
  200: string
}

export type UpdateLineItem2Response = UpdateLineItem2Responses[keyof UpdateLineItem2Responses]

export type DeleteAddressData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/addresses/{id}'
}

export type DeleteAddressErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Tried deleting a primary address. This cannot be achieved by API, only on the ITscope plattform.
   */
  403: string
  /**
   * Could not find an address for the provided id
   */
  404: string
}

export type DeleteAddressError = DeleteAddressErrors[keyof DeleteAddressErrors]

export type UpdateAddressData = {
  body: ShopAddressDto
  path: {
    id: string
  }
  query?: never
  url: '/storefront/addresses/{id}'
}

export type UpdateAddressErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find an address for the provided id
   */
  404: string
}

export type UpdateAddressError = UpdateAddressErrors[keyof UpdateAddressErrors]

export type ReadEmployeesData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/user'
}

export type ReadEmployeesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * You have no admin right or the right to see your colleagues
   */
  403: Array<ShortUser>
}

export type ReadEmployeesError = ReadEmployeesErrors[keyof ReadEmployeesErrors]

export type DeleteUserData = {
  body?: never
  path: {
    userId: string
  }
  query?: never
  url: '/storefront/user/{userId}'
}

export type DeleteUserErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * You have no right to delete
   */
  403: string
  /**
   * Could not find a user for the provided id
   */
  404: string
}

export type DeleteUserError = DeleteUserErrors[keyof DeleteUserErrors]

export type GetEmployeeByIdData = {
  body?: never
  path: {
    userId: string
  }
  query?: never
  url: '/storefront/user/{userId}'
}

export type GetEmployeeByIdErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find user for provided id
   */
  403: User
}

export type GetEmployeeByIdError = GetEmployeeByIdErrors[keyof GetEmployeeByIdErrors]

export type GetCurrentUserData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/user/me'
}

export type GetCurrentUserErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCurrentUserError = GetCurrentUserErrors[keyof GetCurrentUserErrors]

export type GetCurrentUserResponses = {
  /**
   * Here you are
   */
  200: User
}

export type GetCurrentUserResponse = GetCurrentUserResponses[keyof GetCurrentUserResponses]

export type LoginData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/user/actions/login'
}

export type LoginErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find user
   */
  404: string
}

export type LoginError = LoginErrors[keyof LoginErrors]

export type LoginResponses = {
  /**
   * The Basic Auth is valid
   */
  200: string
}

export type LoginResponse = LoginResponses[keyof LoginResponses]

export type AccessTokenData = {
  body?: never
  headers: {
    Authorization: string
  }
  path?: never
  query?: never
  url: '/storefront/user/actions/access-token'
}

export type AccessTokenErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find valid token
   */
  404: AuthTokens
}

export type AccessTokenError = AccessTokenErrors[keyof AccessTokenErrors]

export type AccessTokenResponses = {
  /**
   * The refresh token is valid
   */
  200: AuthTokens
}

export type AccessTokenResponse = AccessTokenResponses[keyof AccessTokenResponses]

export type SubsidiariesData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/subsidiaries'
}

export type SubsidiariesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SubsidiariesError = SubsidiariesErrors[keyof SubsidiariesErrors]

export type SubsidiariesResponses = {
  /**
   * OK
   */
  200: Array<Subsidiary>
}

export type SubsidiariesResponse = SubsidiariesResponses[keyof SubsidiariesResponses]

export type SwitchToSubsidiaryData = {
  body?: never
  path: {
    subsidiaryId: string
  }
  query?: never
  url: '/storefront/subsidiaries/{subsidiaryId}/token'
}

export type SwitchToSubsidiaryErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Token is invalid
   */
  401: string
}

export type SwitchToSubsidiaryError = SwitchToSubsidiaryErrors[keyof SwitchToSubsidiaryErrors]

export type SwitchToSubsidiaryResponses = {
  /**
   * The token is valid
   */
  200: string
}

export type SwitchToSubsidiaryResponse =
  SwitchToSubsidiaryResponses[keyof SwitchToSubsidiaryResponses]

export type SearchForSubsidiariesData = {
  body?: never
  path?: never
  query?: {
    keyword?: string
  }
  url: '/storefront/subsidiaries/search'
}

export type SearchForSubsidiariesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SearchForSubsidiariesError =
  SearchForSubsidiariesErrors[keyof SearchForSubsidiariesErrors]

export type SearchForSubsidiariesResponses = {
  /**
   * OK
   */
  200: PageableResponseSubsidiary
}

export type SearchForSubsidiariesResponse =
  SearchForSubsidiariesResponses[keyof SearchForSubsidiariesResponses]

export type ImpersonationStatusData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/subsidiaries/impersonation-status'
}

export type ImpersonationStatusErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ImpersonationStatusError = ImpersonationStatusErrors[keyof ImpersonationStatusErrors]

export type ImpersonationStatusResponses = {
  /**
   * OK
   */
  200: ImpersonationStatus
}

export type ImpersonationStatusResponse =
  ImpersonationStatusResponses[keyof ImpersonationStatusResponses]

export type FeaturedData = {
  body?: never
  path?: never
  query?: {
    /**
     * Results page you want to retrieve (0..N)
     */
    page?: number
    /**
     * Number of records per page.
     */
    size?: number
  }
  url: '/storefront/startpages'
}

export type FeaturedErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type FeaturedError = FeaturedErrors[keyof FeaturedErrors]

export type FeaturedResponses = {
  /**
   * OK
   */
  200: StartPage
}

export type FeaturedResponse = FeaturedResponses[keyof FeaturedResponses]

export type SearchProductSliceData = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path?: never
  query?: {
    keyword?: string
    filters?: Array<string>
    quick?: boolean
    /**
     * last key of previous slice
     */
    lastKey?: number
    /**
     * Number of records per page.
     */
    size?: number
    /**
     * RELEVANCE = Best match first, POPULARITY = Popularity descending, NAME_ASC = Product name ascending, NAME_DESC = Product name descending, PRICE_ASC = Wholesale price ascending, PRICE_DESC = Wholesale price descending, AVAILABILITY = Availability descending, STOCK = Stock quantity descending
     */
    sort?: StorefrontProductSort
  }
  url: '/storefront/search-products'
}

export type SearchProductSliceErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SearchProductSliceError = SearchProductSliceErrors[keyof SearchProductSliceErrors]

export type SearchProductSliceResponses = {
  /**
   * Returns slice with items, hasNext and lastKey
   */
  200: SliceMediumProduct
}

export type SearchProductSliceResponse =
  SearchProductSliceResponses[keyof SearchProductSliceResponses]

export type GetCustomTermsData = {
  body?: never
  path?: never
  query?: {
    lang?: string
  }
  url: '/storefront/registration/customterms'
}

export type GetCustomTermsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCustomTermsError = GetCustomTermsErrors[keyof GetCustomTermsErrors]

export type GetCustomTermsResponses = {
  /**
   * OK
   */
  200: CustomTerms
}

export type GetCustomTermsResponse = GetCustomTermsResponses[keyof GetCustomTermsResponses]

export type LoadQuotesData = {
  body?: never
  path?: never
  query?: {
    filter?: string
    keyword?: string
    /**
     * Results page you want to retrieve (0..N)
     */
    page?: number
    /**
     * Number of records per page.
     */
    size?: number
    /**
     * DATE_ASC = Sent date ascending, DATE_DESC = Sent date descending, VALID_ASC = Valid date date ascending, VALID_DESC = Valid date date descending, LAST_MODIFIED = Last modified date descending, TITLE_ASC = Title ascending, TITLE_DESC = Title descending ORGANISATION_ASC = Organisation name ascending, ORGANISATION_DESC = Organisation name descending
     */
    sort?: StorefrontQuoteSort
  }
  url: '/storefront/quotes'
}

export type LoadQuotesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type LoadQuotesError = LoadQuotesErrors[keyof LoadQuotesErrors]

export type LoadQuotesResponses = {
  /**
   * OK
   */
  200: PageableResponseShortQuote
}

export type LoadQuotesResponse = LoadQuotesResponses[keyof LoadQuotesResponses]

export type PrintQuoteData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes/{id}/print'
}

export type PrintQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: string
}

export type PrintQuoteError = PrintQuoteErrors[keyof PrintQuoteErrors]

export type GetDataHtmlDatasheetData = {
  body?: never
  path: {
    id: string
    itemId: string
  }
  query?: never
  url: '/storefront/quotes/{id}/items/{itemId}/datasheet'
}

export type GetDataHtmlDatasheetErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Quote item don't have datasheet
   */
  404: string
}

export type GetDataHtmlDatasheetError = GetDataHtmlDatasheetErrors[keyof GetDataHtmlDatasheetErrors]

export type GetActivitySseData = {
  body?: never
  headers: {
    Authorization: string
  }
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes/{id}/activity-sse'
}

export type GetActivitySseErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: Array<ServerSentEventListQuoteActivity>
}

export type GetActivitySseError = GetActivitySseErrors[keyof GetActivitySseErrors]

export type CountNewQuotesData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/quotes/new-count'
}

export type CountNewQuotesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type CountNewQuotesError = CountNewQuotesErrors[keyof CountNewQuotesErrors]

export type CountNewQuotesResponses = {
  /**
   * OK
   */
  200: NewQuotesCount
}

export type CountNewQuotesResponse = CountNewQuotesResponses[keyof CountNewQuotesResponses]

export type GetFiltersData = {
  body?: never
  path?: never
  query?: {
    filter?: string
    keyword?: string
  }
  url: '/storefront/quotes/filters'
}

export type GetFiltersErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: Array<FilterIdentifier>
}

export type GetFiltersError = GetFiltersErrors[keyof GetFiltersErrors]

export type LoadQuoteByIdSseData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/quotes-sse/{id}'
}

export type LoadQuoteByIdSseErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No quote with id found
   */
  404: Array<ServerSentEventQuote>
}

export type LoadQuoteByIdSseError = LoadQuoteByIdSseErrors[keyof LoadQuoteByIdSseErrors]

export type GetIsProductInQuoteRequestData = {
  body?: never
  path: {
    id: number
  }
  query?: never
  url: '/storefront/quote-requests/{id}/hasProduct'
}

export type GetIsProductInQuoteRequestErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetIsProductInQuoteRequestError =
  GetIsProductInQuoteRequestErrors[keyof GetIsProductInQuoteRequestErrors]

export type GetIsProductInQuoteRequestResponses = {
  /**
   * OK
   */
  200: boolean
}

export type GetIsProductInQuoteRequestResponse =
  GetIsProductInQuoteRequestResponses[keyof GetIsProductInQuoteRequestResponses]

export type GetQuoteRequestForProductData = {
  body?: never
  path: {
    id: number
  }
  query?: never
  url: '/storefront/quote-requests/products/{id}'
}

export type GetQuoteRequestForProductErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetQuoteRequestForProductError =
  GetQuoteRequestForProductErrors[keyof GetQuoteRequestForProductErrors]

export type GetQuoteRequestForProductResponses = {
  /**
   * OK
   */
  200: Array<QuoteRequestForProduct>
}

export type GetQuoteRequestForProductResponse =
  GetQuoteRequestForProductResponses[keyof GetQuoteRequestForProductResponses]

export type SearchProductData = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path?: never
  query?: {
    keyword?: string
    filters?: Array<string>
    quick?: boolean
    /**
     * Results page you want to retrieve (0..N)
     */
    page?: number
    /**
     * Number of records per page.
     */
    size?: number
    /**
     * RELEVANCE = Best match first, POPULARITY = Popularity descending, NAME_ASC = Product name ascending, NAME_DESC = Product name descending, PRICE_ASC = Wholesale price ascending, PRICE_DESC = Wholesale price descending, AVAILABILITY = Availability descending, STOCK = Stock quantity descending
     */
    sort?: StorefrontProductSort
  }
  url: '/storefront/products'
}

export type SearchProductErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SearchProductError = SearchProductErrors[keyof SearchProductErrors]

export type SearchProductResponses = {
  /**
   * OK
   */
  200: PageableResponseMediumProduct
}

export type SearchProductResponse = SearchProductResponses[keyof SearchProductResponses]

export type LoadFullProductData = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path: {
    id: number
  }
  query?: never
  url: '/storefront/products/{id}'
}

export type LoadFullProductErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type LoadFullProductError = LoadFullProductErrors[keyof LoadFullProductErrors]

export type LoadFullProductResponses = {
  /**
   * OK
   */
  200: FullProduct
}

export type LoadFullProductResponse = LoadFullProductResponses[keyof LoadFullProductResponses]

export type GetDataHtmlDatasheet1Data = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path: {
    id: number
    type: 'PDF' | 'HTML'
  }
  query?: never
  url: '/storefront/products/{id}/datasheet/{type}'
}

export type GetDataHtmlDatasheet1Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No product with id found
   */
  404: string
}

export type GetDataHtmlDatasheet1Error =
  GetDataHtmlDatasheet1Errors[keyof GetDataHtmlDatasheet1Errors]

export type FilterNodesData = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path?: never
  query?: {
    keyword?: string
    filters?: Array<string>
  }
  url: '/storefront/products/filters'
}

export type FilterNodesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type FilterNodesError = FilterNodesErrors[keyof FilterNodesErrors]

export type FilterNodesResponses = {
  /**
   * OK
   */
  200: ProductFilterResponse
}

export type FilterNodesResponse = FilterNodesResponses[keyof FilterNodesResponses]

export type LoadBundleItemsForProductData = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path: {
    id: number
  }
  query?: never
  url: '/storefront/products/bundle-items/{id}'
}

export type LoadBundleItemsForProductErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No bundle items found
   */
  404: Array<BundleReference>
}

export type LoadBundleItemsForProductError =
  LoadBundleItemsForProductErrors[keyof LoadBundleItemsForProductErrors]

export type LoadAccessoriesForProductData = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path: {
    id: number
  }
  query?: never
  url: '/storefront/products/accessories/{id}'
}

export type LoadAccessoriesForProductErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No accessory groups found
   */
  404: Array<AccessoryGroup>
}

export type LoadAccessoriesForProductError =
  LoadAccessoriesForProductErrors[keyof LoadAccessoriesForProductErrors]

export type GetComparisonData = {
  body?: never
  path?: never
  query: {
    productIds: Array<number>
  }
  url: '/storefront/product-comparison'
}

export type GetComparisonErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Finds a source for technical details for requested products and returns the products with technical data from the found source.
   */
  404: Array<FullProduct>
}

export type GetComparisonError = GetComparisonErrors[keyof GetComparisonErrors]

export type SettingsData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/portalsettings'
}

export type SettingsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SettingsError = SettingsErrors[keyof SettingsErrors]

export type SettingsResponses = {
  /**
   * OK
   */
  200: PortalSettings
}

export type SettingsResponse = SettingsResponses[keyof SettingsResponses]

export type GetOrdersData = {
  body?: never
  path?: never
  query?: {
    status?: string
    archived?: boolean
    creators?: string
    keyword?: string
    /**
     * Results page you want to retrieve (0..N)
     */
    page?: number
    /**
     * Number of records per page.
     */
    size?: number
    /**
     * SENT_DESC = Sent date descending, SENT_ASC = Sent date ascending, ID = Order id ascending, LAST_MODIFIED = Last modified date descending, CREATED_DESC = Created date descending, SUPPLIER = Supplier name ascending, STATUS_DESC = Order status descending, STATUS_ASC = Order status ascending,
     */
    sort?: StorefrontOrderSort
  }
  url: '/storefront/orders'
}

export type GetOrdersErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetOrdersError = GetOrdersErrors[keyof GetOrdersErrors]

export type GetOrdersResponses = {
  /**
   * OK
   */
  200: PageableResponseOrder
}

export type GetOrdersResponse = GetOrdersResponses[keyof GetOrdersResponses]

export type DeletePreparedOrderData = {
  body?: never
  path: {
    orderId: string
  }
  query?: never
  url: '/storefront/orders/{orderId}'
}

export type DeletePreparedOrderErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type DeletePreparedOrderError = DeletePreparedOrderErrors[keyof DeletePreparedOrderErrors]

export type DeletePreparedOrderResponses = {
  /**
   * OK
   */
  200: string
}

export type DeletePreparedOrderResponse =
  DeletePreparedOrderResponses[keyof DeletePreparedOrderResponses]

export type GetOrderData = {
  body?: never
  path: {
    orderId: string
  }
  query?: never
  url: '/storefront/orders/{orderId}'
}

export type GetOrderErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find order for provided id
   */
  404: DetailedOrder
  /**
   * User is in wrong company to access this order
   */
  412: DetailedOrder
}

export type GetOrderError = GetOrderErrors[keyof GetOrderErrors]

export type UpdateTopiOrderData = {
  body?: never
  path: {
    orderId: string
  }
  query?: never
  url: '/storefront/orders/{orderId}/topi'
}

export type UpdateTopiOrderErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * Could not find order for provided id
   */
  404: string
  /**
   * User is in wrong company to access this order
   */
  412: string
}

export type UpdateTopiOrderError = UpdateTopiOrderErrors[keyof UpdateTopiOrderErrors]

export type GetTransactionHistoryData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}/history'
}

export type GetTransactionHistoryErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetTransactionHistoryError =
  GetTransactionHistoryErrors[keyof GetTransactionHistoryErrors]

export type GetTransactionHistoryResponses = {
  /**
   * OK
   */
  200: OrderTransactions
}

export type GetTransactionHistoryResponse =
  GetTransactionHistoryResponses[keyof GetTransactionHistoryResponses]

export type GetDataHtmlDatasheet2Data = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/orders/{id}/documents'
}

export type GetDataHtmlDatasheet2Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No order with id found
   */
  404: string
}

export type GetDataHtmlDatasheet2Error =
  GetDataHtmlDatasheet2Errors[keyof GetDataHtmlDatasheet2Errors]

export type GetDataHtmlDatasheet3Data = {
  body?: never
  path: {
    id: string
    transactionId: string
  }
  query?: never
  url: '/storefront/orders/{id}/documents/{transactionId}'
}

export type GetDataHtmlDatasheet3Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No order with id found
   */
  404: string
}

export type GetDataHtmlDatasheet3Error =
  GetDataHtmlDatasheet3Errors[keyof GetDataHtmlDatasheet3Errors]

export type SearchForOrdersData = {
  body?: never
  path?: never
  query: {
    term: string
  }
  url: '/storefront/orders/search'
}

export type SearchForOrdersErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type SearchForOrdersError = SearchForOrdersErrors[keyof SearchForOrdersErrors]

export type SearchForOrdersResponses = {
  /**
   * OK
   */
  200: Array<OrderSearchModel>
}

export type SearchForOrdersResponse = SearchForOrdersResponses[keyof SearchForOrdersResponses]

export type GetOrderPreviewsData = {
  body?: never
  path?: never
  query?: {
    status?: string
    /**
     * Results page you want to retrieve (0..N)
     */
    page?: number
    /**
     * Number of records per page.
     */
    size?: number
    /**
     * SENT_DESC = Sent date descending, SENT_ASC = Sent date ascending, ID = Order id ascending, LAST_MODIFIED = Last modified date descending, CREATED_DESC = Created date descending, SUPPLIER = Supplier name ascending, STATUS_DESC = Order status descending, STATUS_ASC = Order status ascending,
     */
    sort?: StorefrontOrderSort
  }
  url: '/storefront/orders/preview'
}

export type GetOrderPreviewsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetOrderPreviewsError = GetOrderPreviewsErrors[keyof GetOrderPreviewsErrors]

export type GetOrderPreviewsResponses = {
  /**
   * OK
   */
  200: PageableResponseOrderPreview
}

export type GetOrderPreviewsResponse = GetOrderPreviewsResponses[keyof GetOrderPreviewsResponses]

export type ReadOrderLimitUsersData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/orders/limits/users'
}

export type ReadOrderLimitUsersErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ReadOrderLimitUsersError = ReadOrderLimitUsersErrors[keyof ReadOrderLimitUsersErrors]

export type ReadOrderLimitUsersResponses = {
  /**
   * OK
   */
  200: Array<OrderLimitUser>
}

export type ReadOrderLimitUsersResponse =
  ReadOrderLimitUsersResponses[keyof ReadOrderLimitUsersResponses]

export type ReadApproversData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/orders/limits/approvers'
}

export type ReadApproversErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ReadApproversError = ReadApproversErrors[keyof ReadApproversErrors]

export type ReadApproversResponses = {
  /**
   * OK
   */
  200: Array<ShortUser>
}

export type ReadApproversResponse = ReadApproversResponses[keyof ReadApproversResponses]

export type GetFilterNodesData = {
  body?: never
  path?: never
  query?: {
    status?: string
    archived?: boolean
    keyword?: string
  }
  url: '/storefront/orders/filters'
}

export type GetFilterNodesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetFilterNodesError = GetFilterNodesErrors[keyof GetFilterNodesErrors]

export type GetFilterNodesResponses = {
  /**
   * OK
   */
  200: Array<FilterIdentifier>
}

export type GetFilterNodesResponse = GetFilterNodesResponses[keyof GetFilterNodesResponses]

export type GetTransactionHistory1Data = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/orders/conditions'
}

export type GetTransactionHistory1Errors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetTransactionHistory1Error =
  GetTransactionHistory1Errors[keyof GetTransactionHistory1Errors]

export type GetTransactionHistory1Responses = {
  /**
   * OK
   */
  200: OrderingConditions
}

export type GetTransactionHistory1Response =
  GetTransactionHistory1Responses[keyof GetTransactionHistory1Responses]

export type GetApprovableOrdersData = {
  body?: never
  path?: never
  query?: {
    status?: string
    archived?: boolean
    creators?: string
    keyword?: string
    /**
     * Results page you want to retrieve (0..N)
     */
    page?: number
    /**
     * Number of records per page.
     */
    size?: number
    /**
     * SENT_DESC = Sent date descending, SENT_ASC = Sent date ascending, ID = Order id ascending, LAST_MODIFIED = Last modified date descending, CREATED_DESC = Created date descending, SUPPLIER = Supplier name ascending, STATUS_DESC = Order status descending, STATUS_ASC = Order status ascending,
     */
    sort?: StorefrontOrderSort
  }
  url: '/storefront/orders/approvables'
}

export type GetApprovableOrdersErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetApprovableOrdersError = GetApprovableOrdersErrors[keyof GetApprovableOrdersErrors]

export type GetApprovableOrdersResponses = {
  /**
   * OK
   */
  200: PageableResponseOrder
}

export type GetApprovableOrdersResponse =
  GetApprovableOrdersResponses[keyof GetApprovableOrdersResponses]

export type GetApprovableOrdersFilterNodesData = {
  body?: never
  path?: never
  query?: {
    status?: string
    archived?: boolean
    keyword?: string
  }
  url: '/storefront/orders/approvables/filters'
}

export type GetApprovableOrdersFilterNodesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetApprovableOrdersFilterNodesError =
  GetApprovableOrdersFilterNodesErrors[keyof GetApprovableOrdersFilterNodesErrors]

export type GetApprovableOrdersFilterNodesResponses = {
  /**
   * OK
   */
  200: Array<FilterIdentifier>
}

export type GetApprovableOrdersFilterNodesResponse =
  GetApprovableOrdersFilterNodesResponses[keyof GetApprovableOrdersFilterNodesResponses]

export type SendQuoteEprocurementData = {
  body?: never
  path?: never
  query: {
    quoteId: string
  }
  url: '/storefront/order/actions/send-quote-eprocurement'
}

export type SendQuoteEprocurementErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No order or punchout permission
   */
  403: PunchoutForm
}

export type SendQuoteEprocurementError =
  SendQuoteEprocurementErrors[keyof SendQuoteEprocurementErrors]

export type SendCartEprocurementData = {
  body?: never
  path?: never
  query?: {
    supplierCartId?: string
  }
  url: '/storefront/order/actions/send-cart-eprocurement'
}

export type SendCartEprocurementErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
  /**
   * No order or punchout permission
   */
  403: PunchoutForm
}

export type SendCartEprocurementError = SendCartEprocurementErrors[keyof SendCartEprocurementErrors]

export type GetProductClassesData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/cto/productclasses'
}

export type GetProductClassesErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetProductClassesError = GetProductClassesErrors[keyof GetProductClassesErrors]

export type GetProductClassesResponses = {
  /**
   * OK
   */
  200: Array<ProductClass>
}

export type GetProductClassesResponse = GetProductClassesResponses[keyof GetProductClassesResponses]

export type GetProductClassData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/cto/productclasses/**'
}

export type GetProductClassErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetProductClassError = GetProductClassErrors[keyof GetProductClassErrors]

export type GetProductClassResponses = {
  /**
   * OK
   */
  200: ModelConfiguration
}

export type GetProductClassResponse = GetProductClassResponses[keyof GetProductClassResponses]

export type GetModelGroupsData = {
  body?: never
  path: {
    productClassId: number
  }
  query?: never
  url: '/storefront/cto/modelgroup/{productClassId}'
}

export type GetModelGroupsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetModelGroupsError = GetModelGroupsErrors[keyof GetModelGroupsErrors]

export type GetModelGroupsResponses = {
  /**
   * OK
   */
  200: Array<ModelGroupResource>
}

export type GetModelGroupsResponse = GetModelGroupsResponses[keyof GetModelGroupsResponses]

export type GetCollectionFiltersData = {
  body?: never
  path?: never
  query?: {
    filter?: string
    search?: string
  }
  url: '/storefront/collections/filters'
}

export type GetCollectionFiltersErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCollectionFiltersError = GetCollectionFiltersErrors[keyof GetCollectionFiltersErrors]

export type GetCollectionFiltersResponses = {
  /**
   * OK
   */
  200: Array<FilterIdentifier>
}

export type GetCollectionFiltersResponse =
  GetCollectionFiltersResponses[keyof GetCollectionFiltersResponses]

export type GetCheckoutData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/checkout'
}

export type GetCheckoutErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCheckoutError = GetCheckoutErrors[keyof GetCheckoutErrors]

export type GetCheckoutResponses = {
  /**
   * OK
   */
  200: Checkout
}

export type GetCheckoutResponse = GetCheckoutResponses[keyof GetCheckoutResponses]

export type GetCheckoutByIdData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/checkout/{id}'
}

export type GetCheckoutByIdErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCheckoutByIdError = GetCheckoutByIdErrors[keyof GetCheckoutByIdErrors]

export type GetCheckoutByIdResponses = {
  /**
   * OK
   */
  200: Checkout
}

export type GetCheckoutByIdResponse = GetCheckoutByIdResponses[keyof GetCheckoutByIdResponses]

export type GetCheckoutForQuoteData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/storefront/checkout/quote/{id}'
}

export type GetCheckoutForQuoteErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCheckoutForQuoteError = GetCheckoutForQuoteErrors[keyof GetCheckoutForQuoteErrors]

export type GetCheckoutForQuoteResponses = {
  /**
   * OK
   */
  200: Checkout
}

export type GetCheckoutForQuoteResponse =
  GetCheckoutForQuoteResponses[keyof GetCheckoutForQuoteResponses]

export type GetCheckoutTermsData = {
  body?: never
  path?: never
  query?: {
    /**
     * 2 letter language code according to ISO 639-1, fallback is english
     */
    alpha2language?: string
  }
  url: '/storefront/checkout-terms'
}

export type GetCheckoutTermsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetCheckoutTermsError = GetCheckoutTermsErrors[keyof GetCheckoutTermsErrors]

export type GetCheckoutTermsResponses = {
  /**
   * OK
   */
  200: string
}

export type GetCheckoutTermsResponse = GetCheckoutTermsResponses[keyof GetCheckoutTermsResponses]

export type CategoryTreeData = {
  body?: never
  headers?: {
    'Accept-Language'?: string
  }
  path?: never
  query?: never
  url: '/storefront/categories'
}

export type CategoryTreeErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type CategoryTreeError = CategoryTreeErrors[keyof CategoryTreeErrors]

export type CategoryTreeResponses = {
  /**
   * OK
   */
  200: Array<Category>
}

export type CategoryTreeResponse = CategoryTreeResponses[keyof CategoryTreeResponses]

export type ReadLineItemsData = {
  body?: never
  path?: never
  query?: {
    supplierCartId?: string
    'If true, requests prices from distributor, may take a long time to respond!'?: boolean
    'Country code according to the ISO 3166-1 alpha 3 standard.'?: string
  }
  url: '/storefront/carts'
}

export type ReadLineItemsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ReadLineItemsError = ReadLineItemsErrors[keyof ReadLineItemsErrors]

export type ReadLineItemsResponses = {
  /**
   * OK
   */
  200: Cart
}

export type ReadLineItemsResponse = ReadLineItemsResponses[keyof ReadLineItemsResponses]

export type ReadSupplierCartData = {
  body?: never
  path: {
    supplierCartId: string
  }
  query?: {
    'If true, requests prices from distributor, may take a long time to respond!'?: boolean
    'Country code according to the ISO 3166-1 alpha 3 standard.'?: string
  }
  url: '/storefront/carts/{supplierCartId}'
}

export type ReadSupplierCartErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type ReadSupplierCartError = ReadSupplierCartErrors[keyof ReadSupplierCartErrors]

export type ReadSupplierCartResponses = {
  /**
   * OK
   */
  200: SupplierCart
}

export type ReadSupplierCartResponse = ReadSupplierCartResponses[keyof ReadSupplierCartResponses]

export type GetOptimizationsData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/carts/optimizations'
}

export type GetOptimizationsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetOptimizationsError = GetOptimizationsErrors[keyof GetOptimizationsErrors]

export type GetOptimizationsResponses = {
  /**
   * OK
   */
  200: Array<OptimizationType>
}

export type GetOptimizationsResponse = GetOptimizationsResponses[keyof GetOptimizationsResponses]

export type GetOptimizationData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/carts/optimizations/preview'
}

export type GetOptimizationErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetOptimizationError = GetOptimizationErrors[keyof GetOptimizationErrors]

export type GetOptimizationResponses = {
  /**
   * OK
   */
  200: Array<CartOptimizationResult>
}

export type GetOptimizationResponse = GetOptimizationResponses[keyof GetOptimizationResponses]

export type GetMoveInfoData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/carts/items/move'
}

export type GetMoveInfoErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type GetMoveInfoError = GetMoveInfoErrors[keyof GetMoveInfoErrors]

export type GetMoveInfoResponses = {
  /**
   * OK
   */
  200: CartItemMoveInfo
}

export type GetMoveInfoResponse = GetMoveInfoResponses[keyof GetMoveInfoResponses]

export type CountLineItemsData = {
  body?: never
  path?: never
  query?: {
    supplierCartId?: string
  }
  url: '/storefront/carts/items/count'
}

export type CountLineItemsErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type CountLineItemsError = CountLineItemsErrors[keyof CountLineItemsErrors]

export type CountLineItemsResponses = {
  /**
   * OK
   */
  200: CartItemsCount
}

export type CountLineItemsResponse = CountLineItemsResponses[keyof CountLineItemsResponses]

export type BrandingData = {
  body?: never
  path?: never
  query?: never
  url: '/storefront/branding'
}

export type BrandingErrors = {
  /**
   * Bad Request
   */
  400: StorefrontApiError
}

export type BrandingError = BrandingErrors[keyof BrandingErrors]

export type BrandingResponses = {
  /**
   * OK
   */
  200: Branding
}

export type BrandingResponse = BrandingResponses[keyof BrandingResponses]
